/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */

// add textbox item to sidebar items array user can type in text and it should get saved with the floor planner 
// create as file for download

//add functionality to clear all items from floor planner
//give me the complete code to copy


// redesign this component to look more elegant and polished and accents
// and add a little more pizzaz to the menu items and add hover effects 
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation
//  (e.g. sellerPrimaryColor1 + sellerColorSuffixDark) for tints, never hardcode colors."
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight,
// give me the entire code to copy


// when i hover over a table shape square round or rectabgle
// it shows a gradient with top left corner round
// show me just the relevant code



// give me 2 paramters to paas in to the main component ot show/hide the top and side menu
// the default show be to show both menus
// give me the relevant code and instructions


import React, { useReducer, useRef, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { v4 as uuidv4 } from 'uuid';
import { 
  BsSquare, BsCircle, BsCircleFill, BsGrid3X3Gap, BsPersonVideo3 as LecternIcon,
  BsTrash2
} from 'react-icons/bs';
import { FaSquareFull, FaHandsWash } from "react-icons/fa";
import { FaChevronLeft, FaChevronRight, FaArrowRight, FaArrowLeft, FaList } from "react-icons/fa6";
import { TbRectangle, TbPodium } from 'react-icons/tb';
import { MdRectangle } from "react-icons/md";
import { IoMusicalNotesSharp as MusicBandIcon } from 'react-icons/io5';
import { TfiText } from 'react-icons/tfi';
import { FiZoomIn, FiZoomOut, FiSave, FiRotateCw } from 'react-icons/fi';
import { RxDividerHorizontal } from "react-icons/rx";
import { MdSafetyDivider, MdHighlight, MdOutlineTableBar } from "react-icons/md";
import { PiTreePalmLight, PiTreePalmFill, PiProjectorScreenChartLight } from "react-icons/pi";
import { HiMiniSpeakerWave } from "react-icons/hi2";
import { LuProjector } from "react-icons/lu";
import { MdOutlineLocalBar } from "react-icons/md";
import { GiBooze, GiFlowers, GiCoffeeCup } from "react-icons/gi";
import { RiDrinks2Fill } from "react-icons/ri";
import { GiIonicColumn } from "react-icons/gi";
import { AiFillHourglass } from "react-icons/ai";
import { FaHourglass } from "react-icons/fa";
import { FaBeer, FaWineGlassAlt, FaCocktail } from "react-icons/fa6";
import { RiDeleteBack2Fill } from "react-icons/ri";
import { FaDeleteLeft } from "react-icons/fa6";
import { BsMagnet } from "react-icons/bs";
import { MdDeleteSweep, MdOutlineDeleteSweep, MdOutlineDeleteOutline } from "react-icons/md";

import { update_event_details_floorPlan, get_event_details, messageClear } from '../../store/reducers/eventDetailsReducer';

import GetSellerConfig from '../GetSellerConfig';
import toast from 'react-hot-toast';
import config from '../../config';

const ITEM_TYPES = {
  GUEST_TABLE_SQUARE_6_TO_8_SEATS_48INCH_X_48INCH: 'GUEST_TABLE_SQUARE_6_TO_8_SEATS_48INCH_X_48INCH',
  GUEST_TABLE_SQUARE_8_TO_12_SEATS_60INCH_X_60INCH: 'GUEST_TABLE_SQUARE_8_TO_12_SEATS_60INCH_X_60INCH',
  BUFFET_TABLE_SQUARE_48INCH_X_48INCH: 'BUFFET_TABLE_SQUARE_48INCH_X_48INCH',
  BUFFET_TABLE_SQUARE_60INCH_X_60INCH: 'BUFFET_TABLE_SQUARE_60INCH_X_60INCH',
  GUEST_TABLE_ROUND_8_TO_10_SEATS_60INCH: 'GUEST_TABLE_ROUND_8_TO_10_SEATS_60INCH',
  GUEST_TABLE_ROUND_10_TO_12_SEATS_72INCH: 'GUEST_TABLE_ROUND_10_TO_12_SEATS_72INCH',
  GUEST_TABLE_ROUND_12_TO_14_SEATS_84INCH: 'GUEST_TABLE_ROUND_12_TO_14_SEATS_84INCH',
  BUFFET_TABLE_ROUND_60INCH: 'BUFFET_TABLE_ROUND_60INCH',
  BUFFET_TABLE_ROUND_72INCH: 'BUFFET_TABLE_ROUND_72INCH',
  BUFFET_TABLE_ROUND_84INCH: 'BUFFET_TABLE_ROUND_84INCH',
  GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_30INCH: 'GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_30INCH',
  GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_36INCH: 'GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_36INCH',
  GUEST_TABLE_RECT_12_SEATS_8FEET_X_48INCH: 'GUEST_TABLE_RECT_12_SEATS_8FEET_X_48INCH',
  BUFFET_TABLE_RECT_8FEET_X_30INCH: 'BUFFET_TABLE_RECT_8FEET_X_30INCH',
  BUFFET_TABLE_RECT_8FEET_X_36INCH: 'BUFFET_TABLE_RECT_8FEET_X_36INCH',
  BUFFET_TABLE_RECT_8FEET_X_48INCH: 'BUFFET_TABLE_RECT_8FEET_X_48INCH',
  LECTERN: 'LECTERN',
  MUSIC_BAND: 'MUSIC_BAND',
  TEXT_BOX: 'TEXT_BOX',
  DIVIDER: 'DIVIDER',
  TREE: 'TREE',
  LIGHT: 'LIGHT',
  SPEAKER: 'SPEAKER',
  BAR: 'BAR',
  KIDS_DRINKS: 'KIDS_DRINKS',
  COFFEE_AND_TEA: 'COFFEE_AND_TEA',
  FLOWERS: 'FLOWERS',
  HAND_WASHING: 'HAND_WASHING',
  COLUMN: 'COLUMN',
  DEAD_SPACE: 'DEAD_SPACE',
  LABEL_MEN: 'LABEL_MEN',
  LABEL_WOMEN: 'LABEL_WOMEN',
  LABEL_KIDS: 'LABEL_KIDS',
  LABEL_DANCE_FLOOR: 'LABEL_DANCE_FLOOR',
  LABEL_DAIS: 'LABEL_DAIS',
  LABEL_DEAD_SPACE: 'LABEL_DEAD_SPACE',
  LABEL_TABLE_NUMBER: 'LABEL_TABLE_NUMBER',
  LABEL_0: 'LABEL_0', LABEL_1: 'LABEL_1', LABEL_2: 'LABEL_2', LABEL_3: 'LABEL_3',
  LABEL_4: 'LABEL_4', LABEL_5: 'LABEL_5', LABEL_6: 'LABEL_6', LABEL_7: 'LABEL_7',
  LABEL_8: 'LABEL_8', LABEL_9: 'LABEL_9'
};

const SIDEBAR_ITEMS = [
  { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_SQUARE_6_TO_8_SEATS_48INCH_X_48INCH, label: 'Table', label2: '6–8 Seats', menuShape: 'squareTable', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 44, height: 44, backgroundColor: 'bg-blue-200', name: '48x48 6-8 Seats' } },
  { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_SQUARE_8_TO_12_SEATS_60INCH_X_60INCH, label: 'Table', label2: '8–12 Seats', menuShape: 'squareTable', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 50, height: 50, backgroundColor: 'bg-blue-200', name: '60x60 8-12 Seats' } },
  { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_SQUARE_48INCH_X_48INCH, label: 'Buffet', label2: '48x48', menuShape: 'squareTable', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 44, height: 44, backgroundColor: 'bg-yellow-200', name: 'Buffet 48x48 Table' } },
  { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_SQUARE_60INCH_X_60INCH, label: 'Buffet', label2: '60x60', menuShape: 'squareTable', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 50, height: 50, backgroundColor: 'bg-yellow-200', name: 'Buffet 60x60 Table' } },
  { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_ROUND_8_TO_10_SEATS_60INCH, label: 'Table', label2: '8–10 Seats', menuShape: 'roundTable', icon: <BsCircleFill className="mr-2" />, 
    defaultProps: { width: 44, height: 44, backgroundColor: 'bg-blue-200', name: '60" 8-10 Seats' } },
  { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_ROUND_10_TO_12_SEATS_72INCH, label: 'Table', label2: '10–12 Seats', menuShape: 'roundTable', icon: <BsCircleFill className="mr-2" />, 
    defaultProps: { width: 54, height: 54, backgroundColor: 'bg-blue-200', name: '72" 10-12 Seats' } },
  { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_ROUND_12_TO_14_SEATS_84INCH, label: 'Table', label2: '12–14 Seats', menuShape: 'roundTable', icon: <BsCircleFill className="mr-2" />, 
    defaultProps: { width: 58, height: 58, backgroundColor: 'bg-blue-200', name: '84" 12-14 Seats' } },
  { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_ROUND_60INCH, label: 'Buffet', label2: '60"', menuShape: 'roundTable', icon: <BsCircleFill className="mr-2" />, 
    defaultProps: { width: 50, height: 50, backgroundColor: 'bg-yellow-200', name: 'Buffet 60"Table' } },
  { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_ROUND_72INCH, label: 'Buffet', label2: '72"', menuShape: 'roundTable', icon: <BsCircleFill className="mr-2" />, 
    defaultProps: { width: 54, height: 54, backgroundColor: 'bg-yellow-200', name: 'Buffet 72"Table' } },
  { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_ROUND_84INCH, label: 'Buffet', label2: '84"', menuShape: 'roundTable', icon: <BsCircleFill className="mr-2" />, 
    defaultProps: { width: 58, height: 58, backgroundColor: 'bg-yellow-200', name: 'Buffet 84"Table' } },
  { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_30INCH, label: 'Table 30"', label2: '8–10 Seats', menuShape: 'rectangleTable', icon: <MdRectangle className="mr-2" />, 
    defaultProps: { width: 68, height: 28, backgroundColor: 'bg-blue-200', name: '8\'x30" 8-10 Seats' } },
  { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_36INCH, label: 'Table 36"', label2: '8–10 Seats', menuShape: 'rectangleTable', icon: <MdRectangle className="mr-2" />, 
    defaultProps: { width: 68, height: 32, backgroundColor: 'bg-blue-200', name: '8\'x36" 8-10 Seats' } },
  { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_RECT_12_SEATS_8FEET_X_48INCH, label: 'Table 48"', label2: '12 Seats', menuShape: 'rectangleTable', icon: <MdRectangle className="mr-2" />, 
    defaultProps: { width: 68, height: 36, backgroundColor: 'bg-blue-200', name: '8\'x48" 12 Seats' } },
  { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_30INCH, label: 'Buffet', label2: '30"', menuShape: 'rectangleTable', icon: <MdRectangle className="mr-2" />, 
    defaultProps: { width: 68, height: 28, backgroundColor: 'bg-yellow-200', name: 'Buffet 8\'x30" Table' } },
  { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_36INCH, label: 'Buffet', label2: '36"', menuShape: 'rectangleTable', icon: <MdRectangle className="mr-2" />, 
    defaultProps: { width: 68, height: 32, backgroundColor: 'bg-yellow-200', name: 'Buffet 8\'x36" Table' } },
  { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_48INCH, label: 'Buffet', label2: '48"', menuShape: 'rectangleTable', icon: <MdRectangle className="mr-2" />, 
    defaultProps: { width: 68, height: 36, backgroundColor: 'bg-yellow-200', name: 'Buffet 8\'x48" Table' } },
  { id: uuidv4(), type: ITEM_TYPES.LECTERN, label: 'Lectern', label2: '', menuShape: 'floorItem', icon: <TbPodium className="text-[28px] text-purple-500" />, 
    defaultProps: { width: 40, height: 40, backgroundColor: 'bg-transparent', name: 'Lectern' } },
  { id: uuidv4(), type: ITEM_TYPES.MUSIC_BAND, label: 'Band', label2: '', menuShape: 'floorItem', icon: <MusicBandIcon className="text-[26px] text-pink-500" />, 
    defaultProps: { width: 34, height: 34, backgroundColor: 'bg-transparent', name: 'Stage/Band' } },
  { id: uuidv4(), type: ITEM_TYPES.DIVIDER, label: 'Divider', label2: '', menuShape: 'floorItem', icon: <MdSafetyDivider className="text-[30px] text-slate-500" />, 
    defaultProps: { width: 50, height: 50, backgroundColor: 'bg-transparent', name: 'Divider' } },
  { id: uuidv4(), type: ITEM_TYPES.TREE, label: 'Tree', label2: '', menuShape: 'floorItem', icon: <PiTreePalmFill className="text-[26px] text-emerald-600" />, 
    defaultProps: { width: 50, height: 50, backgroundColor: 'bg-transparent', name: 'Tree' } },
  { id: uuidv4(), type: ITEM_TYPES.LIGHT, label: 'Light', label2: '', menuShape: 'floorItem', icon: <MdHighlight className="text-[28px] text-amber-400" />, 
    defaultProps: { width: 50, height: 50, backgroundColor: 'bg-transparent', name: 'Light' } },
  { id: uuidv4(), type: ITEM_TYPES.SPEAKER, label: 'Speaker', label2: '', menuShape: 'floorItem', icon: <HiMiniSpeakerWave className="text-[26px] text-blue-600" />, 
    defaultProps: { width: 50, height: 50, backgroundColor: 'bg-transparent', name: 'Speaker' } },
  { id: uuidv4(), type: ITEM_TYPES.BAR, label: 'Bar', label2: '', menuShape: 'floorItem', icon: <GiBooze className="text-[26px] text-orange-500" />, 
    defaultProps: { width: 50, height: 50, backgroundColor: 'bg-transparent', name: 'Bar' } },
  { id: uuidv4(), type: ITEM_TYPES.KIDS_DRINKS, label: 'Kids', label2: 'Drinks', menuShape: 'floorItem', icon: <RiDrinks2Fill className="text-[22px] text-orange-400" />, 
    defaultProps: { width: 50, height: 50, backgroundColor: 'bg-transparent', name: 'Kids Drinks' } },
  { id: uuidv4(), type: ITEM_TYPES.COFFEE_AND_TEA, label: 'Coffee', label2: '& Tea', menuShape: 'floorItem', icon: <GiCoffeeCup className="text-[22px] text-amber-700" />, 
    defaultProps: { width: 50, height: 50, backgroundColor: 'bg-transparent', name: 'Coffee and Tea' } },
  { id: uuidv4(), type: ITEM_TYPES.FLOWERS, label: 'Flowers', label2: '', menuShape: 'floorItem', icon: <GiFlowers className="text-[26px] text-rose-400" />, 
    defaultProps: { width: 50, height: 50, backgroundColor: 'bg-transparent', name: 'Flowers' } },
  { id: uuidv4(), type: ITEM_TYPES.HAND_WASHING, label: 'Hand', label2: 'Wash', menuShape: 'floorItem', icon: <FaHandsWash className="text-[22px] text-teal-600" />, 
    defaultProps: { width: 40, height: 40, backgroundColor: 'bg-transparent', name: 'Hand Washing' } },
  { id: uuidv4(), type: ITEM_TYPES.COLUMN, label: 'Column', label2: '', menuShape: 'floorItem', icon: <FaHourglass className="text-[22px] text-slate-400" />, 
    defaultProps: { width: 30, height: 50, backgroundColor: 'bg-transparent', name: 'Column' } },
  { id: uuidv4(), type: ITEM_TYPES.DEAD_SPACE, label: 'Dead', label2: 'Space', menuShape: 'floorItem', icon: <RiDeleteBack2Fill className="text-[24px] text-rose-500" />, 
    defaultProps: { width: 30, height: 30, backgroundColor: 'bg-transparent', name: 'Dead Space' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_MEN, label: 'Men', label2: '', menuShape: 'labelItem', icon: <FaSquareFull />, 
    defaultProps: { width: 30, height: 20, backgroundColor: 'bg-gray-200', name: 'Men' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_WOMEN, label: 'Women', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 42, height: 20, backgroundColor: 'bg-gray-200', name: 'Women' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_KIDS, label: 'Kids', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 30, height: 20, backgroundColor: 'bg-gray-200', name: 'Kids' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_DANCE_FLOOR, label: 'Dance Floor', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 40, height: 34, backgroundColor: 'bg-gray-200', name: 'Dance Floor' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_DAIS, label: 'Dais', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 30, height: 20, backgroundColor: 'bg-gray-200', name: 'Dais' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_DEAD_SPACE, label: 'Dead Space', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 50, height: 30, backgroundColor: 'bg-red-200', name: 'Dead Space' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_TABLE_NUMBER, label: 'Tbl Number', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 50, height: 20, backgroundColor: 'bg-gray-200', name: 'Tbl Num' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_0, label: 'Digit: 0', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '0' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_1, label: 'Digit: 1', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '1' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_2, label: 'Digit: 2', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '2' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_3, label: 'Digit: 3', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '3' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_4, label: 'Digit: 4', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '4' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_5, label: 'Digit: 5', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '5' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_6, label: 'Digit: 6', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '6' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_7, label: 'Digit: 7', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '7' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_8, label: 'Digit: 8', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '8' } },
  { id: uuidv4(), type: ITEM_TYPES.LABEL_9, label: 'Digit: 9', label2: '', menuShape: 'labelItem', icon: <FaSquareFull className="mr-2" />, 
    defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '9' } },
];

const GRID_SIZES = [10, 20, 30, 40, 50];

const initialState = {
  items: {},
  selectedItemId: null,
  zoom: 1,
  gridVisible: true,
  snapToGrid: true,
  gridSize: 20,
  canvasSize: { width: 600, height: 400 },
  nextZIndex: 1,
};

const snapToGridFunc = (value, gridSize, enabled) => {
  if (!enabled) return value;
  return Math.round(value / gridSize) * gridSize;
};

function plannerReducer(state, action) {
  switch (action.type) {
    case 'ADD_ITEM': {
      const newItem = { ...action.payload.defaultProps, id: uuidv4(), type: action.payload.type, x: action.payload.x, y: action.payload.y, rotation: 0, zIndex: state.nextZIndex };
      return { ...state, items: { ...state.items, [newItem.id]: newItem }, selectedItemId: newItem.id, nextZIndex: state.nextZIndex + 1 };
    }
    case 'MOVE_ITEM': {
      const { id, x, y } = action.payload;
      if (!state.items[id]) return state;
      return { ...state, items: { ...state.items, [id]: { ...state.items[id], x, y } } };
    }
    case 'ROTATE_ITEM': {
      const { id, rotationAmount } = action.payload;
      if (!state.items[id]) return state;
      return { ...state, items: { ...state.items, [id]: { ...state.items[id], rotation: ((state.items[id].rotation || 0) + rotationAmount) % 360 } } };
    }
    case 'UPDATE_ITEM_TEXT': {
      const { id, text } = action.payload;
      if (!state.items[id] || state.items[id].type !== ITEM_TYPES.TEXT_BOX) return state;
      return { ...state, items: { ...state.items, [id]: { ...state.items[id], text } } };
    }
    case 'UPDATE_ITEM_SIZE': {
      const { id, width, height } = action.payload;
      if (!state.items[id]) return state;
      return { ...state, items: { ...state.items, [id]: { ...state.items[id], width, height } } };
    }
    case 'SELECT_ITEM': {
      if (action.payload === state.selectedItemId) {
        if (state.items[action.payload] && state.items[action.payload].zIndex < state.nextZIndex - 1) {
          return { ...state, items: { ...state.items, [action.payload]: { ...state.items[action.payload], zIndex: state.nextZIndex } }, nextZIndex: state.nextZIndex + 1, selectedItemId: action.payload };
        }
        return state;
      }
      return { ...state, selectedItemId: action.payload };
    }
    case 'DESELECT_ITEM': return { ...state, selectedItemId: null };
    case 'DELETE_ITEM': {
      if (!state.selectedItemId || !state.items[state.selectedItemId]) return state;
      const newItems = { ...state.items };
      delete newItems[state.selectedItemId];
      return { ...state, items: newItems, selectedItemId: null };
    }
    case 'CLEAR_ALL_ITEMS': return { ...state, items: {}, selectedItemId: null, nextZIndex: 1 };
    case 'SET_ZOOM': return { ...state, zoom: Math.max(0.2, Math.min(action.payload, 3)) };
    case 'TOGGLE_GRID': return { ...state, gridVisible: !state.gridVisible };
    case 'TOGGLE_SNAP_TO_GRID': return { ...state, snapToGrid: !state.snapToGrid };
    case 'SET_GRID_SIZE': return { ...state, gridSize: action.payload };
    case 'LOAD_STATE': {
      const { items, zoom, gridVisible, snapToGrid, gridSize } = action.payload;
      const updatedItems = Object.fromEntries(Object.entries(items).map(([id, item], index) => [id, { ...item, zIndex: item.zIndex || index + 1 }]));
      let maxZ = 0;
      Object.values(updatedItems).forEach(item => { if (item.zIndex > maxZ) maxZ = item.zIndex; });
      return { ...state, items: updatedItems, zoom: zoom || 1, gridVisible: gridVisible !== undefined ? gridVisible : true, snapToGrid: snapToGrid !== undefined ? snapToGrid : true, gridSize: gridSize || 20, selectedItemId: null, nextZIndex: maxZ + 1 };
    }
    default: return state;
  }
}

// ─── Canvas Item ──────────────────────────────────────────────────────────────
const CanvasItem = React.memo(({ item, zoom, onSelect, isSelected, dispatch, snapToGrid, gridSize }) => {
  const itemRef = useRef(null);
  const [isEditingText, setIsEditingText] = useState(false);

  const handleMouseDown = useCallback((e) => {
    e.stopPropagation();
    onSelect(item.id);
    const initialMouseX = e.clientX, initialMouseY = e.clientY;
    const initialItemX = item.x, initialItemY = item.y;
    const handleMouseMove = (moveEvent) => {
      const dx = (moveEvent.clientX - initialMouseX) / zoom;
      const dy = (moveEvent.clientY - initialMouseY) / zoom;
      let newX = initialItemX + dx, newY = initialItemY + dy;
      if (snapToGrid) { newX = snapToGridFunc(newX, gridSize, true); newY = snapToGridFunc(newY, gridSize, true); }
      dispatch({ type: 'MOVE_ITEM', payload: { id: item.id, x: newX, y: newY } });
    };
    const handleMouseUp = () => { document.removeEventListener('mousemove', handleMouseMove); document.removeEventListener('mouseup', handleMouseUp); };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }, [item.id, item.x, item.y, zoom, onSelect, dispatch, snapToGrid, gridSize]);

  const itemStyle = {
    left: `${item.x * zoom}px`, top: `${item.y * zoom}px`,
    width: `${item.width * zoom}px`, height: `${item.height * zoom}px`,
    transform: `rotate(${item.rotation || 0}deg)`, transformOrigin: 'center center', zIndex: item.zIndex || 0,
  };
  const contentStyle = { width: '100%', height: '100%', fontSize: item.type === ITEM_TYPES.TEXT_BOX ? `${(item.fontSize || 16) * zoom}px` : `${1 * zoom}rem` };

  let itemContent;
  const squareTableTypes = [ITEM_TYPES.GUEST_TABLE_SQUARE_6_TO_8_SEATS_48INCH_X_48INCH, ITEM_TYPES.GUEST_TABLE_SQUARE_8_TO_12_SEATS_60INCH_X_60INCH, ITEM_TYPES.BUFFET_TABLE_SQUARE_48INCH_X_48INCH, ITEM_TYPES.BUFFET_TABLE_SQUARE_60INCH_X_60INCH];
  const roundTableTypes = [ITEM_TYPES.GUEST_TABLE_ROUND_8_TO_10_SEATS_60INCH, ITEM_TYPES.GUEST_TABLE_ROUND_10_TO_12_SEATS_72INCH, ITEM_TYPES.GUEST_TABLE_ROUND_12_TO_14_SEATS_84INCH, ITEM_TYPES.BUFFET_TABLE_ROUND_60INCH, ITEM_TYPES.BUFFET_TABLE_ROUND_72INCH, ITEM_TYPES.BUFFET_TABLE_ROUND_84INCH];
  const rectTableTypes = [ITEM_TYPES.GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_30INCH, ITEM_TYPES.GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_36INCH, ITEM_TYPES.GUEST_TABLE_RECT_12_SEATS_8FEET_X_48INCH, ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_30INCH, ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_36INCH, ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_48INCH];

  if (squareTableTypes.includes(item.type)) {
    itemContent = <div className={`w-full h-full ${item.backgroundColor} border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>{item.name}</div>;
  } else if (roundTableTypes.includes(item.type)) {
    itemContent = <div className={`w-full h-full ${item.backgroundColor} rounded-full border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-3 overflow-hidden`}>{item.name}</div>;
  } else if (rectTableTypes.includes(item.type)) {
    itemContent = <div className={`w-full h-full ${item.backgroundColor} border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>{item.name}</div>;
  } else {
    const labelTypes = [ITEM_TYPES.LABEL_MEN, ITEM_TYPES.LABEL_WOMEN, ITEM_TYPES.LABEL_KIDS, ITEM_TYPES.LABEL_DANCE_FLOOR, ITEM_TYPES.LABEL_DAIS, ITEM_TYPES.LABEL_TABLE_NUMBER, ITEM_TYPES.LABEL_0, ITEM_TYPES.LABEL_1, ITEM_TYPES.LABEL_2, ITEM_TYPES.LABEL_3, ITEM_TYPES.LABEL_4, ITEM_TYPES.LABEL_5, ITEM_TYPES.LABEL_6, ITEM_TYPES.LABEL_7, ITEM_TYPES.LABEL_8, ITEM_TYPES.LABEL_9];
    if (item.type === ITEM_TYPES.LABEL_DEAD_SPACE) {
      itemContent = <div className={`w-full h-full ${item.backgroundColor} border border-red-600 flex items-center justify-center text-[10px] font-semibold text-red-600 p-1 overflow-hidden`}>{item.name}</div>;
    } else if (labelTypes.includes(item.type)) {
      itemContent = <div className={`w-full h-full ${item.backgroundColor} border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>{item.name}</div>;
    } else if (item.type === ITEM_TYPES.LECTERN) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-purple-500"><TbPodium className="text-9xl" /></div>;
    } else if (item.type === ITEM_TYPES.MUSIC_BAND) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-pink-500"><MusicBandIcon className="text-9xl" /></div>;
    } else if (item.type === ITEM_TYPES.DIVIDER) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-slate-500"><MdSafetyDivider className="text-9xl" /></div>;
    } else if (item.type === ITEM_TYPES.TREE) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-emerald-600"><PiTreePalmFill className="text-3xl" /></div>;
    } else if (item.type === ITEM_TYPES.LIGHT) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-amber-400"><MdHighlight className="text-3xl" /></div>;
    } else if (item.type === ITEM_TYPES.SPEAKER) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-blue-600"><HiMiniSpeakerWave className="text-3xl" /></div>;
    } else if (item.type === ITEM_TYPES.BAR) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-orange-500"><GiBooze className="text-3xl" /></div>;
    } else if (item.type === ITEM_TYPES.KIDS_DRINKS) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-orange-400"><RiDrinks2Fill className="text-2xl" /></div>;
    } else if (item.type === ITEM_TYPES.COFFEE_AND_TEA) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-amber-700"><GiCoffeeCup className="text-3xl" /></div>;
    } else if (item.type === ITEM_TYPES.FLOWERS) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-rose-400"><GiFlowers className="text-3xl" /></div>;
    } else if (item.type === ITEM_TYPES.HAND_WASHING) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-teal-600"><FaHandsWash className="text-3xl" /></div>;
    } else if (item.type === ITEM_TYPES.COLUMN) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-slate-400"><FaHourglass className="text-3xl" /></div>;
    } else if (item.type === ITEM_TYPES.DEAD_SPACE) {
      itemContent = <div className="w-full h-full flex items-center justify-center text-rose-500"><RiDeleteBack2Fill className="text-3xl" /></div>;
    } else if (item.type === ITEM_TYPES.TEXT_BOX) {
      if (isEditingText) {
        itemContent = <textarea value={item.text} onChange={(e) => dispatch({ type: 'UPDATE_ITEM_TEXT', payload: { id: item.id, text: e.target.value } })} onBlur={() => setIsEditingText(false)} className="w-full h-full p-1 resize-none bg-transparent focus:outline-none focus:ring-1 focus:ring-blue-500" autoFocus onClick={(e) => e.stopPropagation()} />;
      } else {
        itemContent = <div className="w-full h-full p-1 break-words overflow-hidden flex items-center justify-center text-center" onDoubleClick={() => setIsEditingText(true)}>{item.text}</div>;
      }
    } else {
      itemContent = <div className="w-full h-full bg-gray-300 border border-black">?</div>;
    }
  }

  return (
    <div ref={itemRef} className={`absolute cursor-grab ${isSelected ? 'ring-2 ring-blue-400 shadow-xl' : ''}`} style={itemStyle} onMouseDown={handleMouseDown}>
      <div style={contentStyle} className="pointer-events-none">{itemContent}</div>
    </div>
  );
});

// ─── Tooltip wrapper ──────────────────────────────────────────────────────────
const Tooltip = ({ label, children }) => (
  <div className="relative group flex items-center justify-center">
    {children}
    <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 top-full mt-2 z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
      <div className="bg-gray-900 text-white text-[11px] font-medium px-2.5 py-1.5 rounded-lg shadow-xl whitespace-nowrap">
        {label}
        <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-gray-900 rotate-45" />
      </div>
    </div>
  </div>
);

// ─── Toolbar Button ───────────────────────────────────────────────────────────
const ToolbarBtn = ({ tooltip, onClick, disabled, active, activeClass = '', icon, className = '' }) => (
  <Tooltip label={tooltip}>
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        relative flex items-center justify-center w-8 h-8 rounded-md border-none border-black
        transition-all duration-200 ease-out
        ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer hover:scale-105 active:scale-95'}
        ${active ? activeClass || 'bg-white shadow-md ring-1 ring-black/10' : 'hover:bg-white/60 hover:shadow-sm'}
        ${className}
      `}>
      {icon}
    </button>
  </Tooltip>
);

// ─── Sidebar Tile ─────────────────────────────────────────────────────────────
const SidebarTile = ({ item, onDragStart, sellerPrimaryColor1, sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, shape }) => {
  const isFloor = item.menuShape === 'floorItem';
  console.log('shape', shape);
  return (
    <div
      draggable
      onDragStart={(e) => onDragStart(e, item)}
      title={`${item.label}${item.label2 ? ' ' + item.label2 : ''}`}
      className="group relative cursor-grab select-none">
      {/* rounded-xl hover:shadow-lg border-white/60
        transition-all duration-200 ease-out
          hover:scale-105  hover:-translate-y-0.5
          active:scale-95 active:shadow-sm
        */}
      <div
        className={`
          w-full flex flex-col items-center justify-center gap-0.5 border overflow-hidden
          ${shape === 'squareTable' ? '' : ''}
          ${shape === 'roundTable' ? 'rounded-full' : ''}
          ${shape === 'rectangleTable' ? 'h-[38px]' : 'h-[60px]'}
        `}
        style={{
          borderColor: sellerPrimaryColor1 + sellerColorSuffixMedium,
          background: isFloor
            ? `linear-gradient(135deg, #ffffff 0%, ${sellerPrimaryColor1}${sellerColorSuffixLight} 100%)`
            : sellerPrimaryColor1  + sellerColorSuffixLight //`linear-gradient(135deg, ${sellerPrimaryColor1}22 0%, ${sellerPrimaryColor1}0a 100%)`,
          //boxShadow: `0 2px 8px ${sellerPrimaryColor1}20`,
        }}>
        {/* Icon area */}
        {isFloor && (
          <div className="flex items-center justify-center w-full pt-1 pb-0 transition-transform duration-200 
            group-hover:scale-110">
            {item.icon}
          </div>
        )}
        {/* Label */}
        <div className="leading-none text-center px-0.5">
          <div className="text-[10px] font-bold tracking-wide" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
            {item.label}
          </div>
          {item.label2 && (
            <div className="text-[8px] font-medium" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
              {item.label2}
            </div>
          )}
        </div>
      </div>

      {/* Hover shimmer accent */}
      <div
        className="hidden pointer-events-none absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity 
        duration-300"
        style={{
          background: `linear-gradient(135deg, ${sellerPrimaryColor1}30 0%, transparent 60%)`,
          ...(shape === 'roundTable' ? { borderRadius: '9999px' } : {}),
        }}
      />
    </div>
  );
};

// ─── Styled Select ────────────────────────────────────────────────────────────
const StyledSelect = ({ value, onChange, children, style }) => (
  <select
    value={value}
    onChange={onChange}
    className="text-[11px] font-semibold rounded-lg border-0 outline-none py-1 px-2 w-full cursor-pointer transition-all duration-150 hover:opacity-90"
    style={style}>
    {children}
  </select>
);

// ─── Section Card (toolbar grouping) ─────────────────────────────────────────
const ToolGroup = ({ children, className = '', colorLight, colorMedium, colorDark }) => (
  <div className={`flex items-center gap-0.5 pl-1 pr-1 rounded-md  
    bg-white border border-black shadow-sm ${className}`}
    style={{ borderColor: colorDark }}>
    {children}
  </div>
);

// ─── Main Component ───────────────────────────────────────────────────────────
const FloorPlanner = ({ showTopMenu = true, showSideMenu = true}) => {
  const arrCanvasSizes = config.STR_ARR_FLOOR_PLANNER_CANVAS_SIZES;
  const arrRoomSizes = config.STR_ARR_FLOOR_PLANNER_ROOM_SIZES;

  const { loader, userInfo } = useSelector(state => state.auth);
  const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);

  let floorPlanLocal = '';
  if (eventDetails) floorPlanLocal = eventDetails?.floorPlan;
  
  let mainIconSize = 34
  const disabledGray = '#948F8F'

  const {
    sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
    sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
  } = GetSellerConfig();

  const [layoutSaved, setLayoutSaved] = useState(true);
  const [floorPlanNotes, setFloorPlanNotes] = useState('');
  const [floorPlanCanvasHeight, setFloorPlanCanvasHeight] = useState(arrCanvasSizes[0]);
  const [floorPlanCanvasWidth, setFloorPlanCanvasWidth] = useState(arrCanvasSizes[2]);
  const [floorPlanRoomHeight, setFloorPlanRoomHeight] = useState(arrRoomSizes[0]);
  const [floorPlanRoomWidth, setFloorPlanRoomWidth] = useState(arrRoomSizes[0]);
  const [selectedLabelItem, setSelectedLabelItem] = useState('');
  const [selectedTableShape, setSelectedTableShape] = useState('');

  const floorPlannerDispatch = useDispatch();
  const [state, dispatch] = useReducer(plannerReducer, initialState);
  const canvasRef = useRef(null);
  const fileInputRef = useRef(null);
  const { items, selectedItemId, zoom, gridVisible, snapToGrid, gridSize } = state;

  const inputFloorPlanCanvasHeightHandle = (e) => { setFloorPlanCanvasHeight(e.target.value); setLayoutSaved(false); };
  const inputFloorPlanCanvasWidthHandle = (e) => { setFloorPlanCanvasWidth(e.target.value); setLayoutSaved(false); };
  const inputFloorPlanRoomHeightHandle = (e) => { setFloorPlanRoomHeight(e.target.value); setLayoutSaved(false); };
  const inputFloorPlanRoomWidthHandle = (e) => { setFloorPlanRoomWidth(e.target.value); setLayoutSaved(false); };
  const handleFloorPlanNotesChange = (e) => { setFloorPlanNotes(e.target.value); setLayoutSaved(false); };
  const handleGridSizeChange = (e) => { dispatch({ type: 'SET_GRID_SIZE', payload: parseInt(e.target.value) }); setLayoutSaved(false); };
  const handleDragStart = (e, item) => { e.dataTransfer.setData('application/json', JSON.stringify(item)); setLayoutSaved(false); };

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    const itemData = JSON.parse(e.dataTransfer.getData('application/json'));
    if (!canvasRef.current) return;
    const rect = canvasRef.current.getBoundingClientRect();
    const scrollLeft = canvasRef.current.parentElement.scrollLeft || 0;
    const scrollTop = canvasRef.current.parentElement.scrollTop || 0;
    let x = (e.clientX - rect.left + scrollLeft) / zoom;
    let y = (e.clientY - rect.top + scrollTop) / zoom;
    if (snapToGrid) { x = snapToGridFunc(x, gridSize, true); y = snapToGridFunc(y, gridSize, true); }
    dispatch({ type: 'ADD_ITEM', payload: { type: itemData.type, x, y, defaultProps: itemData.defaultProps } });
    setLayoutSaved(false);
  }, [zoom, snapToGrid, gridSize]);

  const handleDragOver = (e) => { e.preventDefault(); };
  const handleCanvasClick = (e) => { if (e.target === canvasRef.current) dispatch({ type: 'DESELECT_ITEM' }); };
  const handleSelectItem = useCallback((itemId) => { dispatch({ type: 'SELECT_ITEM', payload: itemId }); setLayoutSaved(false); }, []);
  const handleRotateSelected = () => { if (selectedItemId) { dispatch({ type: 'ROTATE_ITEM', payload: { id: selectedItemId, rotationAmount: 15 } }); setLayoutSaved(false); } };
  const handleDeleteSelected = () => { if (selectedItemId) { dispatch({ type: 'DELETE_ITEM' }); setLayoutSaved(false); } };

  const handleClearAll = () => {
    const itemCount = Object.keys(items).length;
    if (itemCount === 0) return;
    if (window.confirm(`Remove ALL ${itemCount} item${itemCount !== 1 ? 's' : ''} from the floor plan? This cannot be undone.`)) {
      dispatch({ type: 'CLEAR_ALL_ITEMS' }); setLayoutSaved(false);
    }
  };

  const handleSaveLayout = () => {
    floorPlannerDispatch(update_event_details_floorPlan({
      customerId: userInfo.id,
      floorPlan: JSON.stringify({ items: state.items, zoom: state.zoom, gridVisible: state.gridVisible, snapToGrid: state.snapToGrid, gridSize: state.gridSize, canvasSize: state.canvasSize }, null, 2),
      floorPlanNotes, floorPlanCanvasHeight, floorPlanCanvasWidth, floorPlanRoomHeight, floorPlanRoomWidth,
    }));
    setLayoutSaved(true);
  };

  const handleLoadLayout = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const loadedState = JSON.parse(e.target.result);
          if (loadedState?.items) dispatch({ type: 'LOAD_STATE', payload: loadedState });
        } catch {}
      };
      reader.readAsText(file);
      event.target.value = null;
    }
  };

  const [loadedLayoutJSON, setLoadedLayoutJSON] = useState(false);
  const handleLoadLayoutJSON = () => {
    if (floorPlanLocal && !loadedLayoutJSON) {
      try {
        const loadedState = JSON.parse(floorPlanLocal);
        if (loadedState?.items) {
          setLoadedLayoutJSON(true);
          dispatch({ type: 'LOAD_STATE', payload: loadedState });
          setFloorPlanNotes(eventDetails?.floorPlanNotes);
          setFloorPlanCanvasHeight(eventDetails?.floorPlanCanvasHeight);
          setFloorPlanCanvasWidth(eventDetails?.floorPlanCanvasWidth);
          setFloorPlanRoomHeight(eventDetails?.floorPlanRoomHeight);
          setFloorPlanRoomWidth(eventDetails?.floorPlanRoomWidth);
        }
      } catch {}
    }
  };

  const gridStyle = {
    width: `${floorPlanCanvasWidth * zoom}px`,
    height: `${floorPlanCanvasHeight * zoom}px`,
    backgroundImage: gridVisible
      ? `linear-gradient(to right, #d1d5db ${1 * zoom}px, transparent ${1 * zoom}px), linear-gradient(to bottom, #d1d5db ${1 * zoom}px, transparent ${1 * zoom}px)`
      : 'none',
    backgroundSize: `${gridSize * zoom}px ${gridSize * zoom}px`,
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.key === 'Delete' || event.key === 'Backspace') && selectedItemId) {
        if (document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') handleDeleteSelected();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedItemId]);

  useEffect(() => {
    if (successMessage) { toast.success(successMessage); dispatch(messageClear()); }
    if (errorMessage) { toast.error(errorMessage); dispatch(messageClear()); }
  }, [successMessage, errorMessage]);

  // ── Shared select style ──
  const selectStyle = {
    backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
    color: sellerPrimaryColor1 + sellerColorSuffixDark,
  };

  // const eventName = eventDetails?.eventName;
  // const venueName = eventDetails?.venueName;
  if (eventDetails?.eventName  !== '' || eventDetails?.venueName !== ''){
    mainIconSize = 60
  }

  const itemCount = Object.keys(items).length;

  return (
    <div className="bg-white rounded-2xl">
      <div
        className="rounded-2xl p-4 overflow-hidden"
        style={{
          background: sellerPrimaryColor1 + sellerColorSuffixLight,
          //background: `linear-gradient(160deg, ${sellerPrimaryColor1}12 0%, #ffffff 40%, ${sellerPrimaryColor1}08 100%)`,
          border: `1px solid ${sellerPrimaryColor1}`,
        }}>
        {/* ── Header ── */}
        <div>
          {handleLoadLayoutJSON()}
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <div className="flex items-center gap-2 mb-1 pb-0">
                <div>
                  <MdOutlineTableBar size={mainIconSize} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                </div>
                <div>
                  <div className="text-2xl font-bold tracking-tight leading-none" 
                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                    Floor Planner
                  </div>
                  {eventDetails?.eventName && (
                    <div className="text-md mt-0.5" 
                      style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                      {eventDetails.eventName}{eventDetails.venueName ? ` · ${eventDetails.venueName}` : ''}
                   </div>
                  )}
                </div>
              </div>
            </div>

            {/* unsaved badge */}
              {!layoutSaved && (
                <div className="flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-semibold bg-rose-50 text-rose-500 border border-rose-200 animate-pulse">
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-400 inline-block" />
                  Unsaved changes
                </div>
              )}
            </div>
          </div>

          {/* ── Toolbar ── */}
          {showTopMenu && (
          <>
          <div
            className="2xs:hidden xs:hidden sm:hidden mt-0 mb-0 px-1 py-1 flex flex-wrap items-center gap-0.5"
            style={{
              //background: `linear-gradient(135deg, ${sellerPrimaryColor1}10 0%, transparent 100%)`,
              border: `0px solid ${sellerPrimaryColor1}`,
            }}>
            {/* Zoom group */}
            <ToolGroup 
              colorLight={sellerPrimaryColor1 + sellerColorSuffixLight} 
              colorMedium={sellerPrimaryColor1 + sellerColorSuffixMedium}
              colorDark={sellerPrimaryColor1 + sellerColorSuffixDark}>
              <ToolbarBtn
                tooltip={`Zoom In (${Math.round(zoom * 100)}%)`}
                onClick={() => dispatch({ type: 'SET_ZOOM', payload: zoom * 1.2 })}
                icon={<FiZoomIn size={25} 
                style={{ 
                  color: sellerPrimaryColor1 + sellerColorSuffixDark 
                }} />}
              />
              <div className="text-[11px] font-bold px-1 tabular-nums" 
                style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                Zoom<br />
                {Math.round(zoom * 100)}%
              </div>
              <ToolbarBtn
                tooltip={`Zoom Out (${Math.round(zoom * 100)}%)`}
                onClick={() => dispatch({ type: 'SET_ZOOM', payload: zoom / 1.2 })}
                icon={<FiZoomOut size={25} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />}
              />
            </ToolGroup>

            {/* View group */}
            <ToolGroup
              colorLight={sellerPrimaryColor1 + sellerColorSuffixLight} 
              colorMedium={sellerPrimaryColor1 + sellerColorSuffixMedium}
              colorDark={sellerPrimaryColor1 + sellerColorSuffixDark}>
              <ToolbarBtn
                tooltip={gridVisible ? 'Hide Grid Lines' : 'Show Grid Lines'}
                onClick={() => dispatch({ type: 'TOGGLE_GRID' })}
                active={gridVisible}
                activeClass="bg-white"
                icon={<BsGrid3X3Gap size={22} 
                  style={{ color: gridVisible ? sellerPrimaryColor1 + sellerColorSuffixDark : disabledGray }} />
                }
              />
            </ToolGroup>
            <ToolGroup
              colorLight={sellerPrimaryColor1 + sellerColorSuffixLight} 
              colorMedium={sellerPrimaryColor1 + sellerColorSuffixMedium}
              colorDark={sellerPrimaryColor1 + sellerColorSuffixDark}>
              <ToolbarBtn
                tooltip={snapToGrid ? 'Snap to Grid: On' : 'Snap to Grid: Off'}
                onClick={() => dispatch({ type: 'TOGGLE_SNAP_TO_GRID' })}
                active={snapToGrid}
                activeClass="bg-white"
                icon={<BsMagnet size={22} 
                  style={{ color: snapToGrid ? sellerPrimaryColor1 + sellerColorSuffixDark : disabledGray }} />
                }
              />    
            </ToolGroup>
            {/* Edit group */}
            <ToolGroup
              colorLight={sellerPrimaryColor1 + sellerColorSuffixLight} 
              colorMedium={sellerPrimaryColor1 + sellerColorSuffixMedium}
              colorDark={sellerPrimaryColor1 + sellerColorSuffixDark}>
              <ToolbarBtn
                tooltip="Rotate Selected Item (15°)"
                onClick={handleRotateSelected}
                disabled={!selectedItemId}
                icon={<FiRotateCw size={22} style={{ color: selectedItemId ? sellerPrimaryColor1 + sellerColorSuffixDark : disabledGray }} />} //'#9ca3af'
              />
              <ToolbarBtn
                tooltip="Delete Selected Item  [Del]"
                onClick={handleDeleteSelected}
                disabled={!selectedItemId}
                icon={<MdOutlineDeleteOutline size={26} style={{ color: selectedItemId ? '#ef4444' : '#9ca3af' }} />}
              />
              <ToolbarBtn
                tooltip={itemCount > 0 ? `Clear All ${itemCount} Items` : 'Canvas is Empty'}
                onClick={handleClearAll}
                disabled={itemCount === 0}
                icon={<MdOutlineDeleteSweep size={30} style={{ color: itemCount > 0 ? '#ef4444' : '#9ca3af' }} />}
              />
            </ToolGroup>

            {/* Save */}
            <ToolGroup
              colorLight={sellerPrimaryColor1 + sellerColorSuffixLight} 
              colorMedium={sellerPrimaryColor1 + sellerColorSuffixMedium}
              colorDark={sellerPrimaryColor1 + sellerColorSuffixDark}>
              <ToolbarBtn
                tooltip={layoutSaved ? 'Layout Saved ✓' : 'Save Layout'}
                onClick={handleSaveLayout}
                active={layoutSaved}
                activeClass=""
                className={layoutSaved ? '' : ''} //ring-2 ring-rose-400/60
                icon={<FiSave size={25} className='border-none' style={{ color: layoutSaved ? '#22c55e' : '#ef4444' }} />}
              />
            </ToolGroup>

            {/* Settings group */}
            <ToolGroup className="gap-1"
              colorLight={sellerPrimaryColor1 + sellerColorSuffixLight} 
              colorMedium={sellerPrimaryColor1 + sellerColorSuffixMedium}
              colorDark={sellerPrimaryColor1 + sellerColorSuffixDark}>
              <div className="flex flex-col gap-0">
                <label className="text-[9px] font-bold uppercase tracking-wider" 
                  style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>Grid</label>
                <select value={gridSize} onChange={handleGridSizeChange}
                  className="text-[11px] font-semibold rounded-lg border-0 outline-none py-0.5 px-0.5 cursor-pointer"
                  style={selectStyle}>
                  {GRID_SIZES.map(s => <option key={s} value={s}>{s}px</option>)}
                </select>
              </div>
              <div className="w-px h-5 bg-black/10" />
              <div className="flex flex-col gap-0.5">
                <label className="text-[9px] font-bold uppercase tracking-wider" 
                  style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>Canvas</label>
                <div className="flex gap-1">
                  <select value={floorPlanCanvasHeight} onChange={inputFloorPlanCanvasHeightHandle} 
                    className="text-[11px] font-semibold rounded-lg border-0 outline-none py-0.5 px-0.5 cursor-pointer" 
                    style={selectStyle}>
                    {arrCanvasSizes.map((s, i) => <option key={i} value={s}>H: {s}</option>)}
                  </select>
                  <select value={floorPlanCanvasWidth} onChange={inputFloorPlanCanvasWidthHandle} 
                    className="text-[11px] font-semibold rounded-lg border-0 outline-none py-0.5 px-0.5 cursor-pointer" 
                    style={selectStyle}>
                    {arrCanvasSizes.map((s, i) => <option key={i} value={s}>W: {s}</option>)}
                  </select>
                </div>
              </div>
              <div className="w-px h-5 bg-black/10" />
              <div className="flex flex-col gap-0.5">
                <label className="text-[9px] font-bold uppercase tracking-wider" 
                  style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>Room</label>
                <div className="flex gap-1">
                  <select value={floorPlanRoomHeight} onChange={inputFloorPlanRoomHeightHandle} 
                    className="text-[11px] font-semibold rounded-lg border-0 outline-none py-0.5 px-0.5 cursor-pointer" 
                    style={selectStyle}>
                    {arrRoomSizes.map((s, i) => <option key={i} value={s}>H: {s}ft</option>)}
                  </select>
                  <select value={floorPlanRoomWidth} onChange={inputFloorPlanRoomWidthHandle} 
                    className="text-[11px] font-semibold rounded-lg border-0 outline-none py-0.5 px-0.5 cursor-pointer" 
                    style={selectStyle}>
                    {arrRoomSizes.map((s, i) => <option key={i} value={s}>W: {s}ft</option>)}
                  </select>
                </div>
              </div>
            </ToolGroup>

            <input type="file" ref={fileInputRef} onChange={handleLoadLayout} accept=".json" style={{ display: 'none' }} />
          </div>

          {/* ── Mobile toolbar ── */}
          <div
            className="2xs:flex xs:flex sm:flex hidden items-center gap-2 px-4 py-3"
            style={{ borderBottom: `0px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}` }}>
            <ToolGroup
              colorLight={sellerPrimaryColor1 + sellerColorSuffixLight} 
              colorMedium={sellerPrimaryColor1 + sellerColorSuffixMedium}
              colorDark={sellerPrimaryColor1 + sellerColorSuffixDark}>
              <ToolbarBtn tooltip="Zoom In" onClick={() => dispatch({ type: 'SET_ZOOM', payload: zoom * 1.2 })} icon={<FiZoomIn size={18} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />} />
              <span className="text-[11px] font-bold tabular-nums px-1" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>{Math.round(zoom * 100)}%</span>
              <ToolbarBtn tooltip="Zoom Out" onClick={() => dispatch({ type: 'SET_ZOOM', payload: zoom / 1.2 })} icon={<FiZoomOut size={18} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />} />
            </ToolGroup>
            <span
              className="text-[11px] font-semibold px-3 py-1.5 rounded-xl"
              style={{ 
                background: sellerPrimaryColor1 + sellerColorSuffixLight, 
                color: sellerPrimaryColor1 + sellerColorSuffixDark 
              }}>
              Full toolbar available on wider screens
            </span>
          </div>
          </>
          )}

          {/* ── Body ── */}
          <div className="flex flex-1 overflow-hidden">

            {/* ── Sidebar ── */}
            {showSideMenu && (
            <div
              className="2xs:hidden xs:hidden sm:hidden w-[148px] mr-1 flex-shrink-0 flex flex-col overflow-hidden"
              style={{
                background: sellerPrimaryColor1 + sellerColorSuffixLight, //`linear-gradient(180deg, ${sellerPrimaryColor1}10 0%, ${sellerPrimaryColor1}06 100%)`,
                borderRight: `0px solid ${sellerPrimaryColor1}`,
              }}>
                {/* Sidebar header style={{ borderBottom: `0px solid ${sellerPrimaryColor1}` }}
                */}
                <div className="items-center text-center pt-0.5 pb-0.5 border-none border-black " >
                  <p className="text-[11px] font-bold uppercase tracking-widest" 
                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                    Drag to Canvas
                  </p>
                </div>

                <div className="flex-1 overflow-y-auto px-2 py-1 space-y-1 scrollbar-thin">
                  {/* ── Labels section ── */}
                  <div>
                    <p className="hidden text-[9px] font-bold uppercase tracking-wider px-1 mb-1 border-none border-black" 
                      style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                      Labels
                    </p>
                    <select
                      className="w-full text-[11px] font-semibold rounded-lg border outline-none py-1 px-2 mb-0.5 cursor-pointer"
                      style={{ 
                        borderColor: sellerPrimaryColor1 + sellerColorSuffixMedium,
                        background: sellerPrimaryColor1 + sellerColorSuffixLight, // `linear-gradient(135deg, ${sellerPrimaryColor1}25, ${sellerPrimaryColor1}15)`, 
                        color: sellerPrimaryColor1 + sellerColorSuffixDark 
                      }}
                      value={selectedLabelItem}
                      onChange={(e) => setSelectedLabelItem(e.target.value)}>
                      <option value="">Choose Label…</option>
                      {SIDEBAR_ITEMS.filter(i => i.menuShape === 'labelItem').map(i => (
                        <option key={i.id} value={i.label}>{i.label}</option>
                      ))}
                    </select>
                    {/* Show matched label tile */}
                    {selectedLabelItem && SIDEBAR_ITEMS.filter(i => i.menuShape === 'labelItem' && i.label === selectedLabelItem).map(item => (
                      <div key={item.id} draggable onDragStart={(e) => handleDragStart(e, item)}
                        className="cursor-grab w-full h-6 mt-0.5 rounded-lg border bg-white flex items-center justify-center 
                        text-[10px] font-bold transition-all duration-200 hover:scale-105 hover:shadow-md"
                        style={{ 
                          //background: `linear-gradient(135deg, ${sellerPrimaryColor1}20, ${sellerPrimaryColor1}08)`, 
                          color: sellerPrimaryColor1 + sellerColorSuffixDark, 
                          borderColor: sellerPrimaryColor1 + sellerColorSuffixDark
                        }}>
                        {item.label} Drag <FaArrowRight size={14} className='ml-0.5' />
                      </div>
                    ))}
                  </div>

                  {/* ── Tables section ── */}
                  <div>
                    <p className="hidden text-[9px] font-bold uppercase tracking-wider px-1 mb-1.5" 
                      style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                      Tables
                    </p>
                    <select
                      className="w-full text-[11px] font-semibold rounded-lg border outline-none py-1 px-2 mb-0.5 cursor-pointer"
                      style={{ 
                        borderColor: sellerPrimaryColor1 + sellerColorSuffixMedium,
                        background: sellerPrimaryColor1 + sellerColorSuffixLight, // `linear-gradient(135deg, ${sellerPrimaryColor1}25, ${sellerPrimaryColor1}15)`, 
                        color: sellerPrimaryColor1 + sellerColorSuffixDark 
                      }}
                      value={selectedTableShape}
                      onChange={(e) => setSelectedTableShape(e.target.value)}>
                      <option value="">Table Shape…</option>
                      <option value="squareTable">Square</option>
                      <option value="roundTable">Round</option>
                      <option value="rectangleTable">Rectangle</option>
                    </select>

                    {selectedTableShape && (
                      <div className={`mt-1 grid gap-1 ${selectedTableShape === 'rectangleTable' ? 'grid-cols-2' : 'grid-cols-2'}`}>
                        {SIDEBAR_ITEMS.filter(i => i.menuShape === selectedTableShape).map(item => (
                          <SidebarTile
                            key={item.id} item={item} onDragStart={handleDragStart}
                            sellerPrimaryColor1={sellerPrimaryColor1}
                            sellerColorSuffixDark={sellerColorSuffixDark}
                            sellerColorSuffixMedium={sellerColorSuffixMedium}
                            sellerColorSuffixLight={sellerColorSuffixLight}
                            shape={selectedTableShape}
                          />
                        ))}
                      </div>
                    )}
                  </div>

                  {/* ── Floor Items section ── */}
                  <div>
                    <p className="text-[9px] font-bold uppercase tracking-wider px-1 mb-0.5" 
                      style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                      Floor Items
                    </p>
                    <div className="grid grid-cols-2 gap-1">
                      {SIDEBAR_ITEMS.filter(i => i.menuShape === 'floorItem').map(item => (
                        <SidebarTile
                          key={item.id} item={item} onDragStart={handleDragStart}
                          sellerPrimaryColor1={sellerPrimaryColor1}
                          sellerColorSuffixDark={sellerColorSuffixDark}
                          sellerColorSuffixMedium={sellerColorSuffixMedium}
                          sellerColorSuffixLight={sellerColorSuffixLight}
                          shape="floorItem"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              )}

              {/* ── Canvas area ── */}
              <div className="flex-1 overflow-auto bg-gray-100/60 p-0">
                <div
                  ref={canvasRef}
                  className="relative bg-white shadow-inner"
                  style={gridStyle}
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  onClick={handleCanvasClick}>
                  {Object.values(items).sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0)).map(item => (
                    <CanvasItem
                      key={item.id} item={item} zoom={zoom}
                      onSelect={handleSelectItem} isSelected={item.id === selectedItemId}
                      dispatch={dispatch} snapToGrid={snapToGrid} gridSize={gridSize}
                    />
                  ))}
                </div>

                {/* Notes */}
                <div className="mt-2">
                  <textarea
                    value={floorPlanNotes}
                    onChange={handleFloorPlanNotesChange}
                    placeholder="Add layout notes here…"
                    className="w-full h-[80px] resize-none rounded-md border-0 outline-none px-3 py-2 text-sm 
                    transition-shadow duration-200 placeholder:text-gray-600"
                    style={{
                      width: floorPlanCanvasWidth + 'px',
                      //background: `linear-gradient(135deg, ${sellerPrimaryColor1}08, #ffffff)`,
                      border: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                      color: sellerPrimaryColor1 + sellerColorSuffixDark,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
    </div>
  );
};

export default FloorPlanner;




//before claude redesign
// import React, { useReducer, useRef, useCallback, useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';

// import { v4 as uuidv4 } from 'uuid';
// import { 
//   BsSquare, BsCircle, BsCircleFill, BsGrid3X3Gap, BsPersonVideo3 as LecternIcon,
//   BsTrash2
// } from 'react-icons/bs';
// import { FaSquareFull, FaHandsWash } from "react-icons/fa";
// import { FaChevronLeft, FaChevronRight, FaList } from "react-icons/fa6";
// import { TbRectangle, TbPodium } from 'react-icons/tb';
// import { MdRectangle } from "react-icons/md";
// import { IoMusicalNotesSharp as MusicBandIcon } from 'react-icons/io5';
// import { TfiText } from 'react-icons/tfi';
// import { FiZoomIn, FiZoomOut, FiSave, FiRotateCw } from 'react-icons/fi';
// import { RxDividerHorizontal } from "react-icons/rx";
// import { MdSafetyDivider, MdHighlight, MdOutlineTableBar } from "react-icons/md";
// import { PiTreePalmLight, PiTreePalmFill, PiProjectorScreenChartLight } from "react-icons/pi";
// import { HiMiniSpeakerWave } from "react-icons/hi2";
// import { LuProjector } from "react-icons/lu";
// import { MdOutlineLocalBar } from "react-icons/md";
// import { GiBooze, GiFlowers, GiCoffeeCup } from "react-icons/gi";
// import { RiDrinks2Fill } from "react-icons/ri";
// import { GiIonicColumn } from "react-icons/gi";
// import { AiFillHourglass } from "react-icons/ai";
// import { FaHourglass } from "react-icons/fa";
// import { FaBeer, FaWineGlassAlt, FaCocktail } from "react-icons/fa6";
// import { FaBeer as BeerIcon, FaWineGlassAlt as WineIcon, FaCocktail as CocktailIcon } from 'react-icons/fa6';
// import { RiDeleteBack2Fill } from "react-icons/ri";
// import { FaDeleteLeft } from "react-icons/fa6";
// import { BsMagnet } from "react-icons/bs";
// // ✅ NEW: Import icon for Clear All button
// import { MdDeleteSweep, MdOutlineDeleteSweep, MdOutlineDeleteOutline } from "react-icons/md";

// import { update_event_details_floorPlan, get_event_details, messageClear } from '../../store/reducers/eventDetailsReducer';

// import GetSellerConfig from '../GetSellerConfig';
// import toast from 'react-hot-toast';
// import config from '../../config';

// // rental place to egt tabels sizes
// // https://bandbpartyofnj.com/product-category/furniture-rentals/table-rentals/
// // Item types
// const ITEM_TYPES = {
//   GUEST_TABLE_SQUARE_6_TO_8_SEATS_48INCH_X_48INCH: 'GUEST_TABLE_SQUARE_6_TO_8_SEATS_48INCH_X_48INCH',
//   GUEST_TABLE_SQUARE_8_TO_12_SEATS_60INCH_X_60INCH: 'GUEST_TABLE_SQUARE_8_TO_12_SEATS_60INCH_X_60INCH',
//   BUFFET_TABLE_SQUARE_48INCH_X_48INCH: 'BUFFET_TABLE_SQUARE_48INCH_X_48INCH',
//   BUFFET_TABLE_SQUARE_60INCH_X_60INCH: 'BUFFET_TABLE_SQUARE_60INCH_X_60INCH',

//   GUEST_TABLE_ROUND_8_TO_10_SEATS_60INCH: 'GUEST_TABLE_ROUND_8_TO_10_SEATS_60INCH',
//   GUEST_TABLE_ROUND_10_TO_12_SEATS_72INCH: 'GUEST_TABLE_ROUND_10_TO_12_SEATS_72INCH',
//   GUEST_TABLE_ROUND_12_TO_14_SEATS_84INCH: 'GUEST_TABLE_ROUND_12_TO_14_SEATS_84INCH',
//   BUFFET_TABLE_ROUND_60INCH: 'BUFFET_TABLE_ROUND_60INCH',
//   BUFFET_TABLE_ROUND_72INCH: 'BUFFET_TABLE_ROUND_72INCH',
//   BUFFET_TABLE_ROUND_84INCH: 'BUFFET_TABLE_ROUND_84INCH',

//   GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_30INCH: 'GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_30INCH',
//   GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_36INCH: 'GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_36INCH',
//   GUEST_TABLE_RECT_12_SEATS_8FEET_X_48INCH: 'GUEST_TABLE_RECT_12_SEATS_8FEET_X_48INCH',
//   BUFFET_TABLE_RECT_8FEET_X_30INCH: 'BUFFET_TABLE_RECT_8FEET_X_30INCH',
//   BUFFET_TABLE_RECT_8FEET_X_36INCH: 'BUFFET_TABLE_RECT_8FEET_X_36INCH',
//   BUFFET_TABLE_RECT_8FEET_X_48INCH: 'BUFFET_TABLE_RECT_8FEET_X_48INCH',
  
//   LECTERN: 'LECTERN',
//   MUSIC_BAND: 'MUSIC_BAND',
//   TEXT_BOX: 'TEXT_BOX',
//   DIVIDER: 'DIVIDER',
//   TREE: 'TREE',
//   LIGHT: 'LIGHT',
//   SPEAKER: 'SPEAKER',
//   BAR: 'BAR',
//   KIDS_DRINKS: 'KIDS_DRINKS',
//   COFFEE_AND_TEA: 'COFFEE_AND_TEA',
//   FLOWERS: 'FLOWERS',
//   HAND_WASHING: 'HAND_WASHING',
//   COLUMN: 'COLUMN',
//   DEAD_SPACE: 'DEAD_SPACE',

//   LABEL_MEN: 'LABEL_MEN',
//   LABEL_WOMEN: 'LABEL_WOMEN',
//   LABEL_KIDS: 'LABEL_KIDS',
//   LABEL_DANCE_FLOOR: 'LABEL_DANCE_FLOOR',
//   LABEL_DAIS: 'LABEL_DAIS',
//   LABEL_DEAD_SPACE: 'LABEL_DEAD_SPACE',
//   LABEL_TABLE_NUMBER: 'LABEL_TABLE_NUMBER',
//   LABEL_0: 'LABEL_0',
//   LABEL_1: 'LABEL_1',
//   LABEL_2: 'LABEL_2',
//   LABEL_3: 'LABEL_3',
//   LABEL_4: 'LABEL_4',
//   LABEL_5: 'LABEL_5',
//   LABEL_6: 'LABEL_6',
//   LABEL_7: 'LABEL_7',
//   LABEL_8: 'LABEL_8',
//   LABEL_9: 'LABEL_9'
// };

// // Sidebar items configuration
// const SIDEBAR_ITEMS = [
//   { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_SQUARE_6_TO_8_SEATS_48INCH_X_48INCH, label: 'Table', label2: '6-8 Seats', menuShape: 'squareTable', 
//       icon: <FaSquareFull className="mr-2" />, 
//       defaultProps: { width: 44, height: 44, backgroundColor: 'bg-blue-200', name: '48x48 6-8 Seats' } },
//   { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_SQUARE_8_TO_12_SEATS_60INCH_X_60INCH, label: 'Table', label2: '8-12 Seats', menuShape: 'squareTable', 
//       icon: <FaSquareFull className="mr-2" />, 
//       defaultProps: { width: 48, height: 48, backgroundColor: 'bg-blue-200', name: '60x60 8-12 Seats' } },
//   { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_SQUARE_48INCH_X_48INCH, label: 'Buffet',  label2: '48x48 Table', menuShape: 'squareTable', 
//       icon: <FaSquareFull className="mr-2" />, 
//       defaultProps: { width: 44, height: 44, backgroundColor: 'bg-yellow-200', name: 'Buffet 48x48 Table' } },
//   { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_SQUARE_60INCH_X_60INCH, label: 'Buffet',  label2: '60x60 Table', menuShape: 'squareTable', 
//       icon: <FaSquareFull className="mr-2" />, 
//       defaultProps: { width:48, height: 48, backgroundColor: 'bg-yellow-200', name: 'Buffet 60x60 Table' } },
//   { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_ROUND_8_TO_10_SEATS_60INCH, label: 'Table', label2: '8-10 Seats', menuShape: 'roundTable', 
//       icon: <BsCircleFill className="mr-2" />, 
//       defaultProps: { width: 44, height: 44, backgroundColor: 'bg-blue-200', name: '60" 8-10 Seats' } },
//   { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_ROUND_10_TO_12_SEATS_72INCH, label: 'Table', label2: '10-12 Seats', menuShape: 'roundTable', 
//     icon: <BsCircleFill className="mr-2" />, 
//       defaultProps: { width: 48, height: 48, backgroundColor: 'bg-blue-200', name: '72" 10-12 Seats' } },
//   { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_ROUND_12_TO_14_SEATS_84INCH, label: 'Table',  label2: '12-14 Seats', menuShape: 'roundTable', 
//       icon: <BsCircleFill className="mr-2" />, 
//       defaultProps: { width: 52, height: 52, backgroundColor: 'bg-blue-200', name: '84" 12-14 Seats' } },
//   { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_ROUND_60INCH, label: 'Buffet', label2: '60" Table', menuShape: 'roundTable', 
//       icon: <BsCircleFill className="mr-2" />, 
//       defaultProps: { width: 48, height: 48, backgroundColor: 'bg-yellow-200', name: 'Buffet 60"Table' } },
//   { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_ROUND_72INCH, label: 'Buffet', label2: '72" Table', menuShape: 'roundTable', 
//       icon: <BsCircleFill className="mr-2" />, 
//       defaultProps: { width: 52, height: 52, backgroundColor: 'bg-yellow-200', name: 'Buffet 72"Table' } },
//   { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_ROUND_84INCH, label: 'Buffet', label2: '84" Table', menuShape: 'roundTable', 
//       icon: <BsCircleFill className="mr-2" />, 
//       defaultProps: { width: 56, height: 56, backgroundColor: 'bg-yellow-200', name: 'Buffet 84"Table' } },

//   { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_30INCH, label: 'Table 30"', label2: '8-10 Seats', menuShape: 'rectangleTable', 
//       icon: <MdRectangle className="mr-2" />, 
//       defaultProps: { width: 68, height: 28, backgroundColor: 'bg-blue-200', name: '8\'x30" 8-10 Seats' } },
//   { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_36INCH, label: 'Table 36"', label2: '8-10 Seats', menuShape: 'rectangleTable', 
//       icon: <MdRectangle className="mr-2" />, 
//       defaultProps: { width: 68, height: 32, backgroundColor: 'bg-blue-200', name: '8\'x36" 8-10 Seats' } },
//   { id: uuidv4(), type: ITEM_TYPES.GUEST_TABLE_RECT_12_SEATS_8FEET_X_48INCH, label: 'Table 48"', label2: '12 Seats', menuShape: 'rectangleTable', 
//       icon: <MdRectangle className="mr-2" />, 
//       defaultProps: { width: 68, height: 36, backgroundColor: 'bg-blue-200', name: '8\'x48" 12 Seats' } },
//   { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_30INCH, label: 'Buffet', label2: '30" Table', menuShape: 'rectangleTable', 
//       icon: <MdRectangle className="mr-2" />, 
//       defaultProps: { width: 68, height: 28, backgroundColor: 'bg-yellow-200', name: 'Buffet 8\'x30" Table' } },
//   { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_36INCH, label: 'Buffet', label2: '36" Table', menuShape: 'rectangleTable', 
//       icon: <MdRectangle className="mr-2" />, 
//       defaultProps: { width: 68, height: 32, backgroundColor: 'bg-yellow-200', name: 'Buffet 8\'x36" Table' } },
//   { id: uuidv4(), type: ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_48INCH, label: 'Buffet', label2: '48" Table', menuShape: 'rectangleTable', 
//       icon: <MdRectangle className="mr-2" />, 
//       defaultProps: { width: 68, height: 36, backgroundColor: 'bg-yellow-200', name: 'Buffet 8\'x48" Table' } },

//   { id: uuidv4(), type: ITEM_TYPES.LECTERN, label: 'Lectern',  label2: '', menuShape: 'floorItem', 
//       icon: <TbPodium className="text-[36px] ml-1 text-purple-500" />, 
//       defaultProps: { width: 40, height: 40, backgroundColor: 'bg-transparent', name: 'Lectern' } },
//   { id: uuidv4(), type: ITEM_TYPES.MUSIC_BAND, label: 'Music/',  label2: 'Band', menuShape: 'floorItem', 
//       icon: <MusicBandIcon className="text-[32px] ml-1 mt-1 text-pink-600" />, 
//       defaultProps: { width: 34, height: 34, backgroundColor: 'bg-transparent', name: 'Stage/Band' } },

//   { id: uuidv4(), type: ITEM_TYPES.DIVIDER, label: 'Divider', label2: '', menuShape: 'floorItem', 
//       icon: <MdSafetyDivider className="text-[42px] text-gray-500" />, 
//       defaultProps: { width: 50, height: 50,  backgroundColor: 'bg-transparent', name: 'Divider'} },
//   { id: uuidv4(), type: ITEM_TYPES.TREE, label: 'Tree/', label2: 'Plant', menuShape: 'floorItem', 
//       icon: <PiTreePalmFill className="ml-2 mt-1 text-[30px] text-green-600" />, 
//       defaultProps: { width: 50, height: 50,  backgroundColor: 'bg-transparent', name: 'Tree'} },
//   { id: uuidv4(), type: ITEM_TYPES.LIGHT, label: 'Light', label2: '', menuShape: 'floorItem', 
//       icon: <MdHighlight className="ml-1 mt-1 text-[38px] text-yellow-400" />, 
//       defaultProps: { width: 50, height: 50,  backgroundColor: 'bg-transparent', name: 'Light'} },
//   { id: uuidv4(), type: ITEM_TYPES.SPEAKER, label: 'Speaker', label2: '', menuShape: 'floorItem', 
//       icon: <HiMiniSpeakerWave className="ml-2 mt-2 text-[34px] text-blue-700" />, 
//       defaultProps: { width: 50, height: 50,  backgroundColor: 'bg-transparent', name: 'Speaker'} },
//   { id: uuidv4(), type: ITEM_TYPES.BAR, label: 'Bar', label2: '', menuShape: 'floorItem', 
//       icon: <GiBooze className="ml-2 mt-2 text-[34px] text-orange-600" />, 
//       defaultProps: { width: 50, height: 50,  backgroundColor: 'bg-transparent', name: 'Bar'} },
//   { id: uuidv4(), type: ITEM_TYPES.KIDS_DRINKS, label: 'Kids', label2: 'Drinks', menuShape: 'floorItem', 
//       icon: <RiDrinks2Fill className="ml-3 mt-2 text-[26px] text-orange-600" />, 
//       defaultProps: { width: 50, height: 50,  backgroundColor: 'bg-transparent', name: 'Kids Drinks'} },
//   { id: uuidv4(), type: ITEM_TYPES.COFFEE_AND_TEA, label: 'Coffee/', label2: 'Tea', menuShape: 'floorItem', 
//       icon: <GiCoffeeCup className="ml-3 mt-2 text-[26px] text-orange-600" />, 
//       defaultProps: { width: 50, height: 50,  backgroundColor: 'bg-transparent', name: 'Coffee and Tea'} },
//   { id: uuidv4(), type: ITEM_TYPES.FLOWERS, label: 'Flowers', label2: '', menuShape: 'floorItem', 
//       icon: <GiFlowers className="ml-2 mt-2 text-[34px] text-yellow-800" />, 
//       defaultProps: { width: 50, height: 50,  backgroundColor: 'bg-transparent', name: 'Flowers'} },
//   { id: uuidv4(), type: ITEM_TYPES.HAND_WASHING, label: 'Hand', label2: 'Washing', menuShape: 'floorItem', 
//       icon: <FaHandsWash  className="ml-2 mt-2 text-[26px] text-green-800" />, 
//       defaultProps: { width: 40, height: 40,  backgroundColor: 'bg-transparent', name: 'Hand Washing'} },
//   { id: uuidv4(), type: ITEM_TYPES.COLUMN, label: 'Column', label2: '', menuShape: 'floorItem', 
//       icon: <FaHourglass className="ml-2 mt-2 text-[34px] text-gray-600" />, 
//       defaultProps: { width: 30, height: 50,  backgroundColor: 'bg-transparent', name: 'Column'} },
//   { id: uuidv4(), type: ITEM_TYPES.DEAD_SPACE, label: 'Dead', label2: 'Space', menuShape: 'floorItem', 
//       icon: <RiDeleteBack2Fill className="ml-2 mt-1 text-[30px] text-red-600" />, 
//       defaultProps: { width: 30, height: 30,  backgroundColor: 'bg-transparent', name: 'Dead Space'} },

//   { id: uuidv4(), type: ITEM_TYPES.LABEL_MEN, label: 'Men',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull />, 
//     defaultProps: { width: 30, height: 20, backgroundColor: 'bg-gray-200', name: 'Men' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_WOMEN, label: 'Women',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 42, height: 20, backgroundColor: 'bg-gray-200', name: 'Women' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_KIDS, label: 'Kids',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 30, height: 20, backgroundColor: 'bg-gray-200', name: 'Kids' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_DANCE_FLOOR, label: 'Dance Floor',  label2: 'Floor', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 40, height: 34, backgroundColor: 'bg-gray-200', name: 'Dance Floor' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_DAIS, label: 'Dais',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 30, height: 20, backgroundColor: 'bg-gray-200', name: 'Dais' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_DEAD_SPACE, label: 'Dead Space', label2: 'Space', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />,  
//     defaultProps: { width: 50, height: 30, backgroundColor: 'bg-red-200', name: 'Dead Space' } },

//   { id: uuidv4(), type: ITEM_TYPES.LABEL_TABLE_NUMBER, label: 'Table Number',  label2: 'Number', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 50, height: 20, backgroundColor: 'bg-gray-200', name: 'Tbl Num' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_0, label: 'Table Num Digit: 0',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />,  
//     defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '0' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_1, label: 'Table Num Digit: 1',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '1' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_2, label: 'Table Num Digit: 2',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '2' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_3, label: 'Table Num Digit: 3',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '3' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_4, label: 'Table Num Digit: 4',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '4' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_5, label: 'Table Num Digit: 5',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '5' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_6, label: 'Table Num Digit: 6',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '6' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_7, label: 'Table Num Digit: 7',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '7' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_8, label: 'Table Num Digit: 8',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '8' } },
//   { id: uuidv4(), type: ITEM_TYPES.LABEL_9, label: 'Table Num Digit: 9',  label2: '', menuShape: 'labelItem',
//     icon: <FaSquareFull className="mr-2" />, 
//     defaultProps: { width: 20, height: 20, backgroundColor: 'bg-gray-200', name: '9' } },
// ];

// // Available grid sizes
// const GRID_SIZES = [10, 20, 30, 40, 50];

// const initialState = {
//   items: {},
//   selectedItemId: null,
//   zoom: 1,
//   gridVisible: true,
//   snapToGrid: true,
//   gridSize: 20,
//   canvasSize: { width: 600, height: 400 },
//   nextZIndex: 1,
// };

// // UTILITY FUNCTION: Snap coordinate to grid
// const snapToGridFunc = (value, gridSize, enabled) => {
//   if (!enabled) return value;
//   return Math.round(value / gridSize) * gridSize;
// };

// function plannerReducer(state, action) {
//   switch (action.type) {
//     case 'ADD_ITEM': {
//       const newItem = {
//         ...action.payload.defaultProps,
//         id: uuidv4(),
//         type: action.payload.type,
//         x: action.payload.x,
//         y: action.payload.y,
//         rotation: 0,
//         zIndex: state.nextZIndex,
//       };
//       return {
//         ...state,
//         items: { ...state.items, [newItem.id]: newItem },
//         selectedItemId: newItem.id,
//         nextZIndex: state.nextZIndex + 1,
//       };
//     }
//     case 'MOVE_ITEM': {
//       const { id, x, y } = action.payload;
//       if (!state.items[id]) return state;
//       return {
//         ...state,
//         items: { ...state.items, [id]: { ...state.items[id], x, y } },
//       };
//     }
//     case 'ROTATE_ITEM': {
//       const { id, rotationAmount } = action.payload;
//       if (!state.items[id]) return state;
//       const currentRotation = state.items[id].rotation || 0;
//       return {
//         ...state,
//         items: { ...state.items, [id]: { ...state.items[id], rotation: (currentRotation + rotationAmount) % 360 } },
//       };
//     }
//     case 'UPDATE_ITEM_TEXT': {
//       const { id, text } = action.payload;
//       if (!state.items[id] || state.items[id].type !== ITEM_TYPES.TEXT_BOX) return state;
//       return {
//         ...state,
//         items: { ...state.items, [id]: { ...state.items[id], text } },
//       };
//     }
//     case 'UPDATE_ITEM_SIZE': {
//         const { id, width, height } = action.payload;
//         if (!state.items[id]) return state;
//         return {
//             ...state,
//             items: { ...state.items, [id]: { ...state.items[id], width, height } },
//         };
//     }
//     case 'SELECT_ITEM': {
//       if (action.payload === state.selectedItemId) {
//         if (state.items[action.payload] && state.items[action.payload].zIndex < state.nextZIndex -1) {
//             return {
//                 ...state,
//                 items: { ...state.items, [action.payload]: { ...state.items[action.payload], zIndex: state.nextZIndex } },
//                 nextZIndex: state.nextZIndex + 1,
//                 selectedItemId: action.payload,
//             }
//         }
//         return state;
//       }
//       return { ...state, selectedItemId: action.payload };
//     }
//     case 'DESELECT_ITEM':
//         return { ...state, selectedItemId: null };
//     case 'DELETE_ITEM': {
//       if (!state.selectedItemId || !state.items[state.selectedItemId]) return state;
//       const newItems = { ...state.items };
//       delete newItems[state.selectedItemId];
//       return { ...state, items: newItems, selectedItemId: null };
//     }
//     // ✅ NEW: Clear all items from the canvas
//     case 'CLEAR_ALL_ITEMS': {
//       return {
//         ...state,
//         items: {},
//         selectedItemId: null,
//         nextZIndex: 1,
//       };
//     }
//     case 'SET_ZOOM':
//       return { ...state, zoom: Math.max(0.2, Math.min(action.payload, 3)) };
//     case 'TOGGLE_GRID':
//       return { ...state, gridVisible: !state.gridVisible };
//     case 'TOGGLE_SNAP_TO_GRID':
//       return { ...state, snapToGrid: !state.snapToGrid };
//     case 'SET_GRID_SIZE':
//       return { ...state, gridSize: action.payload };
//     case 'LOAD_STATE': {
//         const { items, zoom, gridVisible, snapToGrid, gridSize } = action.payload;
//         let maxZ = 0;
//         Object.values(items).forEach(item => {
//             if (item.zIndex && item.zIndex > maxZ) {
//                 maxZ = item.zIndex;
//             }
//         });
//         const updatedItems = Object.fromEntries(
//             Object.entries(items).map(([id, item], index) => [
//                 id,
//                 { ...item, zIndex: item.zIndex || index + 1 }
//             ])
//         );
//         maxZ = 0;
//         Object.values(updatedItems).forEach(item => {
//             if (item.zIndex > maxZ) {
//                 maxZ = item.zIndex;
//             }
//         });

//         return {
//             ...state,
//             items: updatedItems,
//             zoom: zoom || 1,
//             gridVisible: gridVisible !== undefined ? gridVisible : true,
//             snapToGrid: snapToGrid !== undefined ? snapToGrid : true,
//             gridSize: gridSize || 20,
//             selectedItemId: null,
//             nextZIndex: maxZ + 1,
//         };
//     }
//     default:
//       return state;
//   }
// }

// // Canvas Item Component
// const CanvasItem = React.memo(({ item, zoom, onSelect, isSelected, dispatch, snapToGrid, gridSize }) => {
//   const itemRef = useRef(null);
//   const [isEditingText, setIsEditingText] = useState(false);

//   const handleMouseDown = useCallback((e) => {
//     e.stopPropagation();
//     onSelect(item.id);
    
//     const initialMouseX = e.clientX;
//     const initialMouseY = e.clientY;
//     const initialItemX = item.x;
//     const initialItemY = item.y;

//     const handleMouseMove = (moveEvent) => {
//       const dx = (moveEvent.clientX - initialMouseX) / zoom;
//       const dy = (moveEvent.clientY - initialMouseY) / zoom;
      
//       let newX = initialItemX + dx;
//       let newY = initialItemY + dy;
      
//       if (snapToGrid) {
//         newX = snapToGridFunc(newX, gridSize, true);
//         newY = snapToGridFunc(newY, gridSize, true);
//       }
      
//       dispatch({ type: 'MOVE_ITEM', payload: { id: item.id, x: newX, y: newY } });
//     };

//     const handleMouseUp = () => {
//       document.removeEventListener('mousemove', handleMouseMove);
//       document.removeEventListener('mouseup', handleMouseUp);
//     };

//     document.addEventListener('mousemove', handleMouseMove);
//     document.addEventListener('mouseup', handleMouseUp);
//   }, [item.id, item.x, item.y, zoom, onSelect, dispatch, snapToGrid, gridSize]);

//   const handleTextChange = (e) => {
//     dispatch({ type: 'UPDATE_ITEM_TEXT', payload: { id: item.id, text: e.target.value } });
//   };
  
//   const handleDoubleClick = () => {
//     if (item.type === ITEM_TYPES.TEXT_BOX) {
//       setIsEditingText(true);
//     }
//   };

//   const handleTextBlur = () => {
//     setIsEditingText(false);
//   };

//   const itemStyle = {
//     left: `${item.x * zoom}px`,
//     top: `${item.y * zoom}px`,
//     width: `${item.width * zoom}px`,
//     height: `${item.height * zoom}px`,
//     transform: `rotate(${item.rotation || 0}deg)`,
//     transformOrigin: 'center center',
//     zIndex: item.zIndex || 0,
//   };

//   const contentStyle = {
//     width: '100%',
//     height: '100%',
//     fontSize: item.type === ITEM_TYPES.TEXT_BOX ? `${(item.fontSize || 16) * zoom}px` : `${1 * zoom}rem`,
//   };

//   let itemContent;
//   switch (item.type) {
//     case ITEM_TYPES.GUEST_TABLE_SQUARE_6_TO_8_SEATS_48INCH_X_48INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.GUEST_TABLE_SQUARE_8_TO_12_SEATS_60INCH_X_60INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.BUFFET_TABLE_SQUARE_48INCH_X_48INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.BUFFET_TABLE_SQUARE_60INCH_X_60INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.GUEST_TABLE_ROUND_8_TO_10_SEATS_60INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           rounded-full border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-3 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.GUEST_TABLE_ROUND_10_TO_12_SEATS_72INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           rounded-full border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-3 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.GUEST_TABLE_ROUND_12_TO_14_SEATS_84INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor}          
//           rounded-full border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-3 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//       case ITEM_TYPES.BUFFET_TABLE_ROUND_60INCH:
//         itemContent = 
//           <div className={`w-full h-full ${item.backgroundColor}          
//             rounded-full border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-3 overflow-hidden`}>
//             {item.name}
//           </div>;
//         break;
//       case ITEM_TYPES.BUFFET_TABLE_ROUND_72INCH:
//         itemContent = 
//           <div className={`w-full h-full ${item.backgroundColor}          
//             rounded-full border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-3 overflow-hidden`}>
//             {item.name}
//           </div>;
//         break;
//       case ITEM_TYPES.BUFFET_TABLE_ROUND_84INCH:
//         itemContent = 
//           <div className={`w-full h-full ${item.backgroundColor}          
//             rounded-full border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-3 overflow-hidden`}>
//             {item.name}
//           </div>;
//         break;
//     case ITEM_TYPES.GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_30INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.GUEST_TABLE_RECT_8_TO_10_SEATS_8FEET_X_36INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.GUEST_TABLE_RECT_12_SEATS_8FEET_X_48INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_30INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_36INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.BUFFET_TABLE_RECT_8FEET_X_48INCH:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-black flex items-center text-center justify-center text-[10px] font-semibold text-black p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LECTERN:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border-none border-black flex items-center justify-center text-xs text-purple-500 p-1 overflow-hidden`}>
//           <TbPodium className="text-9xl" />
//         </div>;
//       break;
//     case ITEM_TYPES.MUSIC_BAND:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border-none border-black flex items-center justify-center text-xs text-pink-600 p-1 overflow-hidden`}>
//           <MusicBandIcon className="text-9xl" />
//         </div>;
//       break;
//       case ITEM_TYPES.DIVIDER:
//         itemContent = 
//           <div className={`w-full h-full ${item.backgroundColor} 
//             border-none border-black flex items-center justify-center text-xs text-gray-500 p-1 overflow-hidden`}>
//             <MdSafetyDivider className="text-9xl" />
//           </div>;
//         break;
//       case ITEM_TYPES.TREE:
//         itemContent = 
//           <div className={`w-full h-full ${item.backgroundColor} 
//             border-none border-black flex items-center justify-center text-xs text-green-600 p-1 overflow-hidden`}>
//             <PiTreePalmFill className="text-3xl" />
//           </div>;
//         break;
//     case ITEM_TYPES.LIGHT:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border-none border-black flex items-center justify-center text-xs text-yellow-400 p-1 overflow-hidden`}>
//           <MdHighlight className="text-3xl" />
//         </div>;
//       break;
//     case ITEM_TYPES.SPEAKER:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border-none border-black flex items-center justify-center text-xs text-blue-700 p-1 overflow-hidden`}>
//           <HiMiniSpeakerWave className="text-3xl" />
//         </div>;
//       break;
//     case ITEM_TYPES.BAR:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border-none border-black flex items-center justify-center text-xs text-orange-600 p-1 overflow-hidden`}>
//           <GiBooze className="text-3xl" />
//         </div>;
//       break;
//     case ITEM_TYPES.KIDS_DRINKS:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border-none border-black flex items-center justify-center text-xs text-orange-600 p-1 overflow-hidden`}>
//           <RiDrinks2Fill className="text-2xl" />
//         </div>;
//       break;
//     case ITEM_TYPES.COFFEE_AND_TEA:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border-none border-black flex items-center justify-center text-xs text-orange-600 p-1 overflow-hidden`}>
//           <GiCoffeeCup className="text-3xl" />
//         </div>;
//       break;
//     case ITEM_TYPES.FLOWERS:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border-none border-black flex items-center justify-center text-xs text-yellow-800 p-1 overflow-hidden`}>
//           <GiFlowers className="text-3xl" />
//         </div>;
//       break;
//     case  ITEM_TYPES.HAND_WASHING:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border-none border-black flex items-center justify-center text-xs text-green-800 p-1 overflow-hidden`}>
//           <FaHandsWash className="text-3xl" />
//         </div>;
//       break;
//     case ITEM_TYPES.COLUMN:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border-none border-black flex items-center justify-center text-xs text-gray-500 p-1 overflow-hidden`}>
//           <FaHourglass className="text-3xl" /> 
//         </div>;
//       break;
//       case ITEM_TYPES.DEAD_SPACE:
//         itemContent = 
//           <div className={`w-full h-full ${item.backgroundColor} 
//             border-none border-black flex items-center justify-center text-xs text-red-600 p-1 overflow-hidden`}>
//             <RiDeleteBack2Fill className="text-3xl" /> 
//           </div>;
//         break;
//     case ITEM_TYPES.LABEL_MEN:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;  
//     case ITEM_TYPES.LABEL_WOMEN:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;  
//     case ITEM_TYPES.LABEL_KIDS:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name} 
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_DANCE_FLOOR:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_DAIS:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor}  
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_DEAD_SPACE:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor}  
//           border border-red-600 flex items-center justify-center text-[10px] font-semibold text-red-600 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_TABLE_NUMBER:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_0:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_1:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_2:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_3:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_4:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_5:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_6:
//       itemContent =   
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_7:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_8:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.LABEL_9:
//       itemContent = 
//         <div className={`w-full h-full ${item.backgroundColor} 
//           border border-gray-700 flex items-center justify-center text-[10px] font-semibold text-gray-700 p-1 overflow-hidden`}>
//           {item.name}
//         </div>;
//       break;
//     case ITEM_TYPES.TEXT_BOX:
//       if (isEditingText) {
//         itemContent = (
//           <textarea
//             value={item.text}
//             onChange={handleTextChange}
//             onBlur={handleTextBlur}
//             className="w-full h-full p-1 resize-none bg-transparent focus:outline-none focus:ring-1 focus:ring-blue-500"
//             style={{ fontSize: contentStyle.fontSize, lineHeight: `${(item.fontSize || 16) * 1.2 * zoom}px` }}
//             autoFocus
//             onClick={(e) => e.stopPropagation()}
//           />
//         );
//       } else {
//         itemContent = (
//           <div 
//             className="w-full h-full p-1 break-words overflow-hidden flex items-center justify-center text-center"
//             style={{ fontSize: contentStyle.fontSize, lineHeight: `${(item.fontSize || 16) * 1.2 * zoom}px` }}
//             onDoubleClick={handleDoubleClick}
//           >
//             {item.text}
//           </div>
//         );
//       }
//       break;
//     default:
//       itemContent = <div className="w-full h-full bg-gray-300 border border-black">Unknown</div>;
//   }
  
//   return (
//     <div
//       ref={itemRef}
//       className={`absolute cursor-grab ${isSelected ? 'ring-2 ring-blue-500 shadow-lg' : ''} ${item.type === ITEM_TYPES.TEXT_BOX && isSelected ? 'border border-dashed border-blue-600' : ''}`}
//       style={itemStyle}
//       onMouseDown={handleMouseDown}
//     >
//       <div style={contentStyle} className="pointer-events-none">
//          {itemContent}
//       </div>
//     </div>
//   );
// });

// // Main Planner Component
// const FloorPlanner = () => {
//   const arrCanvasSizes = config.STR_ARR_FLOOR_PLANNER_CANVAS_SIZES;
//   const arrRoomSizes = config.STR_ARR_FLOOR_PLANNER_ROOM_SIZES;
  
//   const { loader,  userInfo } = useSelector(state => state.auth);
//   const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);
  
//   let floorPlanLocal = ''
//   if (eventDetails) {
//     floorPlanLocal = eventDetails?.floorPlan
//   }
  
//   //const { seller } = useSelector(state => state.seller)
  
//   const { 
//     sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//     sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//   } = GetSellerConfig();

//   const [ layoutSaved, setLayoutSaved ] = useState(true);
//   const [ floorPlanNotes, setFloorPlanNotes ] = useState('');
//   const [ floorPlanCanvasHeight, setFloorPlanCanvasHeight ] = useState(arrCanvasSizes[0]);
//   const [ floorPlanCanvasWidth, setFloorPlanCanvasWidth ] = useState(arrCanvasSizes[2]);
//   const [ floorPlanRoomHeight, setFloorPlanRoomHeight ] = useState(arrRoomSizes[0]);
//   const [ floorPlanRoomWidth, setFloorPlanRoomWidth ] = useState(arrRoomSizes[0]);

//   const [ selectedLabelItem, setSelectedLabelItem ] = useState(''); 
//   const [ selectedTableShape, setSelectedTableShape ] = useState('');

//   const floorPlannerDispatch = useDispatch()
//   const [state, dispatch] = useReducer(plannerReducer, initialState);
//   const canvasRef = useRef(null);
//   const fileInputRef = useRef(null);

//   const { items, selectedItemId, zoom, gridVisible, snapToGrid, gridSize, canvasSize } = state;

//   const inputFloorPlanCanvasHeightHandle = (e) => {
//     setFloorPlanCanvasHeight(e.target.value);
//     setLayoutSaved(false);
//   }
//   const inputFloorPlanCanvasWidthHandle = (e) => {
//     setFloorPlanCanvasWidth(e.target.value);
//     setLayoutSaved(false);
//   }

//   const inputFloorPlanRoomHeightHandle = (e) => {
//     setFloorPlanRoomHeight(e.target.value);
//     setLayoutSaved(false);
//   }
//   const inputFloorPlanRoomWidthHandle = (e) => {
//     setFloorPlanRoomWidth(e.target.value);
//     setLayoutSaved(false);
//   }

//   const handleFloorPlanNotesChange = (e) => {
//     setFloorPlanNotes(e.target.value);
//     setLayoutSaved(false);
//   }

//   const handleGridSizeChange = (e) => {
//     const newGridSize = parseInt(e.target.value);
//     dispatch({ type: 'SET_GRID_SIZE', payload: newGridSize });
//     setLayoutSaved(false);
//   };

//   const handleDragStart = (e, item) => {
//     e.dataTransfer.setData('application/json', JSON.stringify(item));
//     setLayoutSaved(false);
//   };

//   const handleDrop = useCallback((e) => {
//     e.preventDefault();
//     const itemData = JSON.parse(e.dataTransfer.getData('application/json'));
//     if (!canvasRef.current) return;
  
//     const rect = canvasRef.current.getBoundingClientRect();
//     const scrollLeft = canvasRef.current.parentElement.scrollLeft || 0;
//     const scrollTop = canvasRef.current.parentElement.scrollTop || 0;

//     let x = (e.clientX - rect.left + scrollLeft) / zoom;
//     let y = (e.clientY - rect.top + scrollTop) / zoom;
    
//     if (snapToGrid) {
//       x = snapToGridFunc(x, gridSize, true);
//       y = snapToGridFunc(y, gridSize, true);
//     }
    
//     dispatch({ type: 'ADD_ITEM', payload: { type: itemData.type, x, y, defaultProps: itemData.defaultProps } });
//     setLayoutSaved(false);
//   }, [zoom, snapToGrid, gridSize]);

//   const handleDragOver = (e) => {
//     setLayoutSaved(false);
//     e.preventDefault();
//   };

//   const handleCanvasClick = (e) => {
//     setLayoutSaved(false);
//     if (e.target === canvasRef.current) {
//         dispatch({ type: 'DESELECT_ITEM' });
//     }
//   };

//   const handleSelectItem = useCallback((itemId) => {
//     dispatch({ type: 'SELECT_ITEM', payload: itemId });
//     setLayoutSaved(false);
//   }, []);

//   const handleRotateSelected = () => {
//     if (selectedItemId) {
//       dispatch({ type: 'ROTATE_ITEM', payload: { id: selectedItemId, rotationAmount: 15 } });
//       setLayoutSaved(false);
//     }
//   };
  
//   const handleDeleteSelected = () => {
//     if (selectedItemId) {
//         dispatch({ type: 'DELETE_ITEM' });
//         setLayoutSaved(false);
//     }
//   };

//   // ✅ NEW: Clear all items with confirmation dialog
//   const handleClearAll = () => {
//     const itemCount = Object.keys(items).length;
//     if (itemCount === 0) return;
//     if (window.confirm(`Are you sure you want to remove ALL ${itemCount} item${itemCount !== 1 ? 's' : ''} from the floor plan?\nThis cannot be undone.`)) {
//       dispatch({ type: 'CLEAR_ALL_ITEMS' });
//       setLayoutSaved(false);
//     }
//   };

//   const handleSaveLayout = () => {
//     const layoutToSave = {
//       items: state.items,
//       zoom: state.zoom,
//       gridVisible: state.gridVisible,
//       snapToGrid: state.snapToGrid,
//       gridSize: state.gridSize,
//       canvasSize: state.canvasSize,
//     };
//     const json = JSON.stringify(layoutToSave, null, 2);

//     floorPlannerDispatch(update_event_details_floorPlan({
//         customerId: userInfo.id,
//         floorPlan: json,
//         floorPlanNotes: floorPlanNotes,
//         floorPlanCanvasHeight: floorPlanCanvasHeight,
//         floorPlanCanvasWidth: floorPlanCanvasWidth,
//         floorPlanRoomHeight: floorPlanRoomHeight,
//         floorPlanRoomWidth: floorPlanRoomWidth
//     }))
//     setLayoutSaved(true);
//   };

//   const handleLoadLayout = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         try {
//           const loadedState = JSON.parse(e.target.result);
//           if (loadedState && loadedState.items) {
//             dispatch({ type: 'LOAD_STATE', payload: loadedState });
//           } else {
//             console.error("Invalid file format");
//           }
//         } catch (error) {
//           console.error("Failed to parse JSON:", error);
//         }
//       };
//       reader.readAsText(file);
//       event.target.value = null;
//     }
//   };

//   const [loadedLayoutJSON, setLoadedLayoutJSON] = useState(false)

//   const handleLoadLayoutJSON = () => {
//     if (floorPlanLocal !== undefined && floorPlanLocal !== '' && floorPlanLocal !== null) {
//       try {
//         const loadedState = JSON.parse(floorPlanLocal)
//         if (loadedState && loadedState.items && !loadedLayoutJSON ){
//             setLoadedLayoutJSON(true);
//             dispatch({ type: 'LOAD_STATE', payload: loadedState });
//             setFloorPlanNotes(eventDetails?.floorPlanNotes);
//             setFloorPlanCanvasHeight(eventDetails?.floorPlanCanvasHeight);
//             setFloorPlanCanvasWidth(eventDetails?.floorPlanCanvasWidth);
//             setFloorPlanRoomHeight(eventDetails?.floorPlanRoomHeight);
//             setFloorPlanRoomWidth(eventDetails?.floorPlanRoomWidth);
//         }
//       } catch (error) {
//           console.error("Failed to parse JSON:", error);
//       }
//     }
//   }
  
//   const gridStyle = {
//     floorPlanCanvasWidth : floorPlanCanvasWidth,
//     floorPlanCanvasHeight : floorPlanCanvasHeight,

//     width: `${floorPlanCanvasWidth * zoom}px`,
//     height: `${floorPlanCanvasHeight * zoom}px`,
    
//     backgroundImage: gridVisible
//       ? `linear-gradient(to right, #e0e0e0 ${1 * zoom}px, transparent ${1*zoom}px), linear-gradient(to bottom, #e0e0e0 ${1*zoom}px, transparent ${1*zoom}px)`
//       : 'none',
//     backgroundSize: `${gridSize * zoom}px ${gridSize * zoom}px`,
//   };

//   // Keyboard listener for delete
//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if ((event.key === 'Delete' || event.key === 'Backspace') && selectedItemId) {
//         if (document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
//             handleDeleteSelected();
//         }
//       }
//     };
//     window.addEventListener('keydown', handleKeyDown);
//     return () => {
//       window.removeEventListener('keydown', handleKeyDown);
//     };
//   }, [selectedItemId]);

//   useEffect(() => { 
//       if (successMessage) {
//           toast.success(successMessage)
//           dispatch(messageClear())  
//       } 
//       if (errorMessage) {
//           toast.error(errorMessage)
//           dispatch(messageClear())  
//       } 
//   },[successMessage, errorMessage])
    
//   return (
//     <div className='bg-white rounded-2xl'>
//       <div className='p-4 border rounded-2xl'
//         style={{
//           backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight, 
//           color:sellerPrimaryColor1 + sellerColorSuffixDark, 
//           borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
//         }}>
//         { handleLoadLayoutJSON() }
//       <div className=' flex flex-col mb-2 ' style={{color:sellerPrimaryColor1}}>
//         <span className='text-2xl flex font-bold'>
//           <MdOutlineTableBar className='mt-1 mr-1' /> Floor Planner
//         </span>
//         <span className={` ${eventDetails?.eventName === '' ? 'hidden' : ''}   text-sm`}>{eventDetails?.eventName} - {eventDetails?.venueName}</span>
//       </div>

//       <div className="2xs:hidden xs:hidden sm:hidden mb-2 flex items-center space-x-1 justify-left">
//         <div className='p-0.5 border-none rounded-lg'
//           style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//           <div className="flex items-center">
//             <button title="Zoom In" onClick={() => dispatch({ type: 'SET_ZOOM', payload: zoom * 1.2 })} 
//               className="pl-2 pr-1 rounded hover:bg-gray-200"><FiZoomIn size={18} /></button>
//             <button title="Zoom Out" onClick={() => dispatch({ type: 'SET_ZOOM', payload: zoom / 1.2 })} 
//               className="pl-1 pr-2 rounded hover:bg-gray-200"><FiZoomOut size={18} /></button>
//           </div>
//           <div className="flex items-center place-content-center">
//             <span className="text-[10px] font-semibold" style={{color:sellerPrimaryColor1}}>
//               Zoom: {Math.round(zoom * 100)}%
//             </span>
//           </div>
//         </div>

//         <div onClick={() => dispatch({ type: 'TOGGLE_GRID' })} className='p-1 border-none rounded-lg cursor-pointer'
//           style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//           <button title="Toggle Show/Hide Grid" tooltip="Toggle Show /Hide Grid"
//             className={`rounded ${gridVisible ? 'font-bold' : 'text-gray-400 font-normal'} hover:bg-gray-200`}>
//             <BsGrid3X3Gap size={20} />
//           </button>  
//           <table className="hidden" cellPadding={0} cellSpacing={0}>
//             <tr>
//               <td></td>
//               <td>
//                 <div className="flex items-center place-content-center">
//                   <span className="text-[11px] font-semibold" style={{color:sellerPrimaryColor1}}>
//                     Grid<br/>Lines {gridVisible ? 'On' : 'Off'}
//                   </span>
//                 </div>    
//               </td>
//             </tr>
//           </table>
//         </div>

//         {/* Snap to Grid Toggle Button */}
//         <div onClick={() => dispatch({ type: 'TOGGLE_SNAP_TO_GRID' })} className='p-0.5 border-none rounded-lg cursor-pointer'
//           style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//           <button title="Toggle Snap to Grid" 
//             className={`rounded ${snapToGrid ? 'font-bold' : 'text-gray-400 font-normal'} hover:bg-gray-200`}>
//             <BsMagnet size={20} />
//           </button>
//           <table className="hidden" cellPadding={0} cellSpacing={0}>
//             <tr>
//               <td></td>
//               <td className="">
//                 <div className="flex items-center place-content-center">
//                   <span className="text-[11px] font-semibold" style={{color:sellerPrimaryColor1}}>
//                     Snap<br/>{snapToGrid ? 'On' : 'Off'}
//                   </span>
//                 </div>    
//               </td>
//             </tr>
//           </table>
//         </div>

//         <div onClick={handleRotateSelected} disabled={!selectedItemId} 
//           className='p-0.5 border-none rounded-lg cursor-pointer'
//           style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//           <button title="Rotate Selected Item" tooltip="Rotate Selected Item"
//             className={` ${selectedItemId ? 'font-bold' : 'text-gray-400 font-normal'} rounded`}>
//             <FiRotateCw size={20} />
//           </button>
//           <table className="hidden" cellPadding={0} cellSpacing={0}>
//             <tr>
//               <td></td>
//               <td>
//                 <div className="flex items-center place-content-center">
//                   <span className="text-[11px] font-semibold" style={{color:sellerPrimaryColor1}}>
//                   Select Item<br/>And Rotate</span>
//                 </div>    
//               </td>
//             </tr>
//           </table>
//         </div>

//         <div onClick={handleDeleteSelected} disabled={!selectedItemId} className='p-0 border-none cursor-pointer'
//           style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>

//           <button title="Delete Selected Item" tooltip="Delete Selected Item"
//             className={` ${selectedItemId ? 'text-red-600 font-bold' : 'text-gray-400 font-normal'} rounded`}>
//             <MdOutlineDeleteOutline size={25} />
//           </button>

//           <table className="hidden" cellPadding={0} cellSpacing={0}>
//             <tr>
//               <td></td>
//               <td>
//                 <div className="flex items-center place-content-center">
//                   <span className="text-[11px] font-semibold" style={{color:sellerPrimaryColor1}}>
//                     Select Item<br/>And Delete
//                   </span>
//                 </div>    
//               </td>
//             </tr>          
//           </table>
//         </div>

//         {/* ✅ NEW: Clear All Items Button */}
//         {
//         // <div
//         //   onClick={handleClearAll}
//         //   className='p-0.5 border-none rounded-lg cursor-pointer'
//         //   style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//         //   <button
//         //     title="Clear All Items"
//         //     className={`rounded ${Object.keys(items).length > 0 ? 'text-red-600 font-bold' : 'text-gray-400 font-normal'} hover:bg-gray-200`}>
//         //     <MdDeleteSweep size={22} />
//         //   </button>
//         //   <div className="flex items-center place-content-center">
//         //     <span className="text-[10px] font-semibold" style={{color: Object.keys(items).length > 0 ? 'red' : 'inherit'}}>
//         //       Clear
//         //     </span> 
//         //   </div>
//         // </div>
//         // try mb-2 or pb-2 to push up icon
//         // <div className={`${Object.keys(items).length > 0 ? 'flex flex-col items-center text-red-600' : 'text-gray-400'} 
//         //      border-none border-yellow-600`}>
//         //      <div className={`${Object.keys(items).length > 0 ? '' : 'hidden'} text-red-600 text-[10px]`} >
//         //         Clear
//         //     </div>
//         //   </div>
//         }
//         <div onClick={handleClearAll}
//           className={`${Object.keys(items).length > 0 ? 'border-red-600' : 'border-gray-400'} 
//           p-0 border-none cursor-pointer`}>
//           <button title="Clear All Items"className={`${Object.keys(items).length > 0 ? 'text-red-600' : 'text-gray-400'} 
//             border-none border-yellow-600`}>
//             <MdOutlineDeleteSweep size={28} />
//           </button>
//         </div>

//         <div onClick={handleSaveLayout} 
//           className={`${layoutSaved ? ' border-green-600' : ' border-red-600'} p-0 border-none cursor-pointer`}>
//           <div className={`${layoutSaved ? ' text-green-600' : 'flex flex-col items-center text-red-600'} 
//             border-none border-yellow-600`}>
//             <button title="Save Layout" 
//               className={`${layoutSaved ? ' text-green-600' : ' text-red-600'} border-none border-yellow-600`}>
//               <FiSave size={20} />
//             </button>
//             <div className={`${layoutSaved ? 'hidden' : ''} text-[10px] text-red-600 font-bold`}>Save</div>
//          </div>
          
//           <div className="hidden border border-black">
//             <span className={`${layoutSaved ? 'hidden' : ''} text-[10px] text-red-600 font-bold`}>Save</span>
//             <span className={`${layoutSaved ? 'hidden' : 'hidden'} text-[11px] text-green-600 font-bold`}>Layout<br/>Saved</span>
//           </div>
//           <table className="hidden" cellPadding={0} cellSpacing={0}>
//             <tr>
//               <td></td>
//             </tr>
//             <tr>
//             <td align="center" className="">
//                 <div className="flex items-center place-content-center">
//                   <span className={`${layoutSaved ? 'hidden' : ''} text-[10px] text-red-600 font-bold`}>Save</span>
//                   <span className={`${layoutSaved ? 'hidden' : 'hidden'} text-[11px] text-green-600 font-bold`}>Layout<br/>Saved</span>
//                 </div>
//               </td>
//             </tr>
//           </table>
//         </div>
        
//         {/* Grid Size Dropdown */}
//         <div className='p-0.5 border rounded-md'
//           style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
          
//           <div className="flex w-full">
//             <span className="text-[11px] w-[50px] font-semibold" style={{color:sellerPrimaryColor1}}>Grid Box Size:</span>
//             <select name='gridSize' id='gridSize' value={gridSize} onChange={handleGridSizeChange}
//               className='px-0 py-0 text-[11px] outline-none rounded-md'>
//               {
//                 GRID_SIZES.map((size) => (
//                   <option key={size} value={size}>{size} Px</option>
//                 ))
//               }
//             </select>
//           </div>
        
//         </div>

//         <div className='p-0.5 border rounded-md'
//           style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//           <div className="flex w-full">
//             <span className="text-[11px] w-[78px] font-semibold" style={{color:sellerPrimaryColor1}}>Layout Height: </span>
//             <select name='canvasSizeHeight' id='canvasSizeHeight' 
//               value={floorPlanCanvasHeight} onChange={inputFloorPlanCanvasHeightHandle}
//               className='px-0 py-0 mb-1 text-[11px] outline-none rounded-md'>
//               {
//                 arrCanvasSizes.map((size, index) => (
//                   <option key={index} value={size}>{size} Px</option>
//                 ))
//               }
//             </select>
//           </div>
//           <div className="flex w-full">
//             <span className="text-[11px] w-[78px] font-semibold" style={{color:sellerPrimaryColor1}}>Layout Width: </span>
//             <select name='canvasSizeWidth' id='canvasSizeWidth' 
//               value={floorPlanCanvasWidth} onChange={inputFloorPlanCanvasWidthHandle}
//               className='px-0 py-0 text-[11px] outline-none rounded-md'>
//               {
//                 arrCanvasSizes.map((size, index) => (
//                   <option key={index} value={size}>{size} Px</option>
//                 ))    
//               }
//             </select>
//           </div>
//         </div>
//         <div className='p-0.5 pr-1 pl-1 border rounded-md'
//           style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//           <div className="flex w-full">
//             <span className="text-[11px] w-[74px] font-semibold" style={{color:sellerPrimaryColor1}}>Room Height: </span>
//             <select name='roomSizeHeight' id='roomSizeHeight' 
//               value={floorPlanRoomHeight} onChange={inputFloorPlanRoomHeightHandle}
//               className='px-0 py-0 mb-1 text-[11px] outline-none rounded-md'>
//               {
//                 arrRoomSizes.map((size, index) => (
//                   <option key={index} value={size}>{size} Ft</option>
//                 ))
//               }
//             </select> 
//           </div>
//           <div className="flex w-full">
//             <span className="text-[11px] w-[74px] font-semibold" style={{color:sellerPrimaryColor1}}>Room Width: </span>
//             <select name='roomSizeWidth' id='roomSizeWidth' 
//               value={floorPlanRoomWidth} onChange={inputFloorPlanRoomWidthHandle}
//               className='px-0 py-0 text-[11px] outline-none rounded-md'>
//               {
//                 arrRoomSizes.map((size, index) => (
//                   <option key={index} value={size}>{size} Ft</option>
//                 ))
//               }
//             </select>
//           </div>
//         </div>
//         <button title="Load Layout" onClick={() => fileInputRef.current && fileInputRef.current.click()} 
//           className="hidden p-2 rounded hover:bg-gray-200">Load</button>
//         <input type="file" ref={fileInputRef} onChange={handleLoadLayout} accept=".json" style={{ display: 'none' }} />
        
//         {selectedItemId && items[selectedItemId] && <span className="hidden text-sm text-gray-600 ml-4">Selected: {items[selectedItemId].name || items[selectedItemId].type}</span>}
//       </div>

//       <div className='2xs:flex xs:flex sm:flex md:hidden md-lg:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden text-[12px] font-semibold mb-2'
//         style={{color:sellerPrimaryColor1}}>
//          <div className='p-1 border rounded-lg'
//           style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//           <div className="flex items-center">
//             <button title="Zoom In" onClick={() => dispatch({ type: 'SET_ZOOM', payload: zoom * 1.2 })} 
//               className="pl-2 pr-2 rounded hover:bg-gray-200"><FiZoomIn size={20} /></button>
//             <button title="Zoom Out" onClick={() => dispatch({ type: 'SET_ZOOM', payload: zoom / 1.2 })} 
//               className="pl-2 pr-2 rounded hover:bg-gray-200"><FiZoomOut size={20} /></button>
//           </div>
//           <div className="flex items-center place-content-center">
//             <span className="text-[12px] font-semibold" style={{color:sellerPrimaryColor1}}>Zoom: {Math.round(zoom * 100)}%</span>
//           </div>
//         </div>
//         <div className='p-1 border rounded-lg'
//           style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//           Full Functionality On Bigger Screens
//           </div>
//       </div>
      
//       <div className="flex flex-1 overflow-hidden">
//         <div className="2xs:hidden xs:hidden sm:hidden w-[130px] h-[490px] bg-gray-50 p-1 space-y-1 border-r border-gray-300 overflow-y-auto">
//           <div className="text-lg font-semibold mb-1" 
//             style={{color:sellerPrimaryColor1}}>
//             Floor Items
//           </div>

//           <div className='w-[104px]'>
//             <select className='w-[104px] h-[22px] mb-0 border-2 px-0 py-0 font-semibold text-[11px] outline-none'
//               value={selectedLabelItem} onChange={(e) => setSelectedLabelItem(e.target.value)}
//               style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//               <option value="">Choose Label</option>
//               {
//                 SIDEBAR_ITEMS.filter(item => item.menuShape === 'labelItem')
//                   .map(item => (
//                     <option key={item.id} value={item.label}>{item.label}</option>
//                   ))
//               }
//             </select>
//           </div>
//           <div className={`${selectedLabelItem === '' ? '' : ''} w-[104px]`}>
//           {
//               SIDEBAR_ITEMS.filter(item => item.menuShape === 'labelItem')
//                 .sort((a, b) => a.label.localeCompare(b.label)).map(item => (
//                 <div
//                   key={item.id}
//                   draggable
//                   onDragStart={(e) => handleDragStart(e, item)}
//                   className="  ">
//                   <div className={`${item.menuShape === 'labelItem' && item.label === selectedLabelItem ? '' : 'hidden'} 
//                     w-[104px] h-[20px] cursor-grab border-gray-600 bg-gray-200 border-2 items-center text-center justify-center text-[10px] font-semibold overflow-hidden`}>
//                     <div>{item.label}</div>
//                   </div>
//                 </div>
//               ))
//             }
//           </div>

//           <div className=' w-[104px]'>
//             <select className='w-[104px] h-[22px] mb-0 border-2 px-0 py-0 font-semibold text-[11px] outline-none'
//               value={selectedTableShape} onChange={(e) => setSelectedTableShape(e.target.value)}
//               style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//               <option value="">Table Shape</option>
//               <option value="squareTable">Square Table</option>
//               <option value="roundTable">Round Table</option>
//               <option value="rectangleTable">Rectangle Table</option>
//             </select>
//           </div>

//           <div className='grid grid-cols-2 gap-1 items-center text-center justify-center' >
            
//             {SIDEBAR_ITEMS.map(item => (
//               <div
//                 key={item.id}
//                 draggable
//                 onDragStart={(e) => handleDragStart(e, item)}
//                 className=" cursor-grab ">
                
//                 <div className={`${selectedTableShape === 'squareTable' ? '' : 'hidden'} `}>
//                   <div className={`${item.menuShape === 'squareTable' ? '' : 'hidden'} 
//                     w-[50px] h-[50px] pt-2 border-2 items-center text-center justify-center text-[9px] font-bold overflow-hidden`}
//                     style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                     <div>{item.label}</div>
//                     <div>{item.label2}</div>
//                   </div>
//                 </div>

//                 <div className={`${selectedTableShape === 'roundTable' ? '' : 'hidden'} `}>
//                   <div className={`${item.menuShape === 'roundTable' ? '' : 'hidden'} 
//                     w-[50px] h-[50px] pt-2 rounded-full border-2 items-center text-center justify-center text-[9px] font-bold overflow-hidden`}
//                     style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                     <div>{item.label}</div>
//                     <div>{item.label2}</div>
//                   </div>
//                 </div>
                
//                 <div className={`${selectedTableShape === 'rectangleTable' ? '' : 'hidden'} `}>
//                   <div className={`${item.menuShape === 'rectangleTable' ? '' : 'hidden'} 
//                     w-[50px] h-[34px] pt-0 border-2 items-center text-center justify-center text-[9px] font-bold overflow-hidden`}
//                     style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                     <div>{item.label}</div>
//                     <div>{item.label2}</div>
//                   </div>
//                 </div>

//                 <div className={`${item.menuShape === 'floorItem' ? '' : 'hidden'} 
//                   w-[50px] h-[66px] pt-0 border items-center text-center justify-center text-[10px] font-bold overflow-hidden`}
//                   style={{color:sellerPrimaryColor1}}>
//                   <div className='w-[48px] place-content-center items-center text-center justify-center' >{item.icon}</div>
//                   <div>{item.label}</div>
//                   <div>{item.label2}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
        
//         <div className="flex-1 overflow-auto bg-gray-200 p-0">
//             <div
//             ref={canvasRef}
//             className="relative bg-white shadow-lg"
//             style={gridStyle}
//             onDrop={handleDrop}
//             onDragOver={handleDragOver}
//             onClick={handleCanvasClick}
//             >
//             {Object.values(items).sort((a,b) => (a.zIndex || 0) - (b.zIndex || 0)).map(item => (
//                 <CanvasItem
//                   key={item.id}
//                   item={item}
//                   zoom={zoom}
//                   onSelect={handleSelectItem}
//                   isSelected={item.id === selectedItemId}
//                   dispatch={dispatch}
//                   snapToGrid={snapToGrid}
//                   gridSize={gridSize}
//                 />
//             ))}
//             </div>
//             <div className=''>
//               <textarea value={floorPlanNotes} onChange={handleFloorPlanNotesChange} 
//                 className="h-full mt-0 p-2 border border-gray-300 rounded-md"
//                 style={{width:floorPlanCanvasWidth + 'px', height:'90px'}} 
//                 placeholder="Type your notes here ..."/>
//             </div>
//         </div>
//       </div>
//     </div>
//     </div>
//   );
// };

// export default FloorPlanner;




